<template>
    <div>

        <config-main-title v-if="!setup">
            Procedimentos
        </config-main-title>

        <div v-if="!em_edicao && !link">

            <template v-if="!setup">

                <div class="form-row mb-0">
                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-filter"
                            type="select"
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            :optionsReload="true"
                            v-model="especialidade">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" @click="incluir_procedimento ()"
                                        :disabled="!especialidade">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Classificação..."
                            type="select"
                            optionsData="id_classe_procedimento"
                            service="classe_procedimentos.index"
                            optionsMode="aql"
                            v-model="classificacao"
                            @input="buscarItems ()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-primary" v-if="classificacao > 2 && lista_dados && lista_dados.length" @click="editar_laudo()"
                                        :disabled="!especialidade">
                                        <i class="fa-solid fa-notes-medical"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input icon="fas fa-search" v-model="search" @input="buscarItems ()">
                            <template v-slot:buttonposb>
                                <importacao :service="service_importacao" @refresh="load()" />
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'A'; dados = null; load()">
                                Ativos
                            </button>
                            <button type="button" class="btn text-nowrap" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'; dados = null; load()">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>

            </template>

            <template v-else>

                <div class="form-row mb-0">
                    <div class="col col-12">
                        <az-input
                            placeholder="Selecione a Especialidade..."
                            icon="fas fa-filter"
                            type="select"
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            :optionsReload="true"
                            v-model="especialidade">
                            <template v-slot:buttonposb>
                                <button type="button" class="btn btn-outline-primary" @click="incluir_procedimento ()"
                                    :disabled="!especialidade">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </template>
                        </az-input>
                    </div>
                </div>

            </template>

        </div>

        <div class="form-row mt-2" v-if="especialidade && especialidade.id_especialidade == 2 && !em_edicao && !link">
            <div class="col col-12">
                <az-input
                    sizing="sm"
                    type="button-group"
                    :optionsList="[
                        { id: 'T', search: 'Todos' }, 
                        { id: 'C', search: 'Com Material Cadastrado' }, 
                        { id: 'S', search: 'Sem Material Cadastrado' }, 
                    ]"
                    @click="buscarItems ()"
                    v-model="filtro_material" />
            </div>
        </div>

        <div v-if="!em_edicao && !link && ( !lista_dados || !Object.keys (lista_dados).length )" class="mt-3">
            <az-empty-state icon="fas fa-filter" msg="Selecione a Especialidade" v-if="!especialidade" />
			<az-empty-state :msg="viewMode == 'A' ? 'Nenhum procedimento habilitado' : 'Nenhum procedimento disponível para essa especialidade'"
                action="Incluir Procedimento" :method="incluir_procedimento" v-else />

            <az-input
                v-if="!especialidade && !$store.state.loading && !setup"
                placeholder="Ou selecione o procedimento..."
                icon="fas fa-play"
                type="autocomplete"
                service="procedimentos.index"
                optionsMode="aql"
                optionsName="procedimentos.index"
                v-model="busca_procedimento"
                ref="info_procedimento"
                @input="selecionarProcedimento ()" />
		</div>

        <div class="progress mt-1 mb-3" v-else-if="!setup">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="link && !em_edicao" class="mt-3">
            <az-loading />
        </div>

        <div v-if="!em_edicao && lista_dados && lista_dados.length && !link">

            <div class="text-right mb-3" v-if="viewMode == 'T' && especialidade && especialidade.id_especialidade != 2">
                <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="enableAll(true)">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    Habilitar Todos
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm" @click="enableAll(false)">
                    <i class="fa fa-times mr-1" aria-hidden="true"></i>
                    Desabilitar Todos
                </button>
            </div>

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" :class="proc.unidade_procedimento && !proc.unidade_procedimento.fl_ativo ? 'list-group-item-secondary' : ''"
                    v-for="(proc, ip) in lista_dados" :key="ip">
                    <span>
                        <a href="#" @click.prevent="editar(proc)" class="h5 card-link mb-0 mr-3"
                            v-if="1==1 || proc.unidade_procedimento.fl_ativo">
                            {{ proc.search }}
                        </a>
                        <span v-else>
                            {{ proc.search }}
                        </span>
                        <span v-if="proc.st_sigla" class="badge badge-secondary ml-2" title="Sigla">
                            {{ proc.st_sigla }}
                        </span>
                        <span class="ml-3 text-muted small" v-if="proc.classe_procedimento">
                            {{ proc.classe_procedimento.st_classe_procedimento }}
                        </span>

                        <div v-if="proc.js_classes && proc.js_classes.length">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in proc.js_classes" :key="itx">
                                <span class="badge badge-success mr-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                    </span>
                    <span class="d-flex">
                        <div v-if="!setup && proc.unidade_procedimento && proc.unidade_procedimento.fl_ativo && !proc.medico_procedimento_unidades_count"
                            class="text-warning ml-2"
                            data-toggle="tooltip" data-placement="top" title="Nenhum prestador habilitado.">
                            <i class="fas fa-exclamation-triangle"></i>
                        </div>
                        <div v-if="proc.procedimento_terceiros && proc.procedimento_terceiros.length">
                            <a href="#" @click.prevent="filtrar_terceiro(terc)" v-for="(terc, itx) in unico(proc.procedimento_terceiros, 'id_terceiro')" :key="itx">
                                <span class="badge ml-2" :class="terc.fl_ativo ? 'badge-success' : 'badge-info'"
                                    :title="terc.terceiro.st_terceiro">
                                    {{ terc.terceiro.st_sigla ? terc.terceiro.st_sigla : terc.terceiro.st_terceiro }}
                                </span>
                            </a>
                        </div>
                        <div v-if="proc.st_codigo_sus || proc.st_codigo_cbhpm">
                            <span class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" :title="proc.st_codigo_cbhpm" v-if="proc.st_codigo_cbhpm">
                                TUSS
                            </span>
                            <span class="badge badge-secondary ml-2" data-toggle="tooltip" data-placement="top" :title="proc.st_codigo_sus" v-if="proc.st_codigo_sus">
                                SUS
                            </span>
                        </div>
                        <div v-if="proc.in_lab_imp_ordem">
                            <span class="badge badge-secondary ml-2" title="Ordem de Impressão Laboratorial.">
                                {{ proc.in_lab_imp_ordem }}
                                <i class="fas fa-sort-amount-down ml-2"></i>
                            </span>
                        </div>
                        <div class="custom-control custom-switch ml-2" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + ip"
                                v-model="proc.unidade_procedimento.fl_ativo"
                                @change="toggle_procedimento(proc.unidade_procedimento)">
                            <label class="custom-control-label" :for="'ativo-' + ip"></label>
                        </div>
                    </span>
                </li>
            </div>

            <importacao ref="imp_comp" service="consumo_procedimentos" :hide="true" />

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.data">
                <div class="d-flex">
                    <template v-if="dados.last_page > 1">
                        <paginate
                            class="mb-0"
                            :page-count="dados.last_page"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-link'"
                            :next-class="'page-link'"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :click-handler="paginar">
                        </paginate>
                    </template>

                    <div class="spinner-border ml-2" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div>
                    <div class="btn-group dropup">
                        <button class="btn btn-primary btn-sm mr-3 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Importar...
                        </button>
                        <div class="dropdown-menu small" aria-labelledby="dropdownMenuButton" @click.prevent="importar_componentes()">
                            <a class="dropdown-item" href="#">Componentes</a>
                        </div>
                    </div>

                    <span>
                        {{ lista_dados.length }} / {{ dados.total }}
                    </span>

                    <!--
                    <button class="btn btn-outline-primary ml-2" @click="abrir_modal_vincular_tuss()" v-if="viewItemMode == 'T'">
                        <i class="fa fa-link mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        {{ ( tabela && tabela.st_aplicacao == 'MIX' ) ? 'Vincular / Código' : 'Vincular / TUSS' }}
                    </button>
                    <button class="btn btn-primary ml-2" @click="abrir_modal_importar()">
                        <i class="fa fa-upload mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        Importar
                    </button>
                    -->
                </div>
            </nav>

            <pre v-if="1 == 0 && !em_edicao">{{ lista_dados }}</pre>

        </div>

        <!-- Formulário de edição de procedimento -->

        <div v-if="em_edicao">

            <az-empty-state v-if="!item" />

            <div class="card" style="padding: 0px;" v-else>

                <div class="card-header bg-success text-white lead" v-if="!item.id_procedimento">
                    Novo 
                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i> 
                    {{ item.especialidade.search }} 
                </div>

                <div class="card-header bg-primary text-white lead d-flex justify-content-between" v-else>
                    <div>
                        {{ item.especialidade.search }}
                    </div>
                    <div>
                        <span class="badge badge-secondary ml-2" v-if="item.st_id_externo">
                            {{ item.st_id_externo }}
                        </span>
                        <span class="badge badge-secondary ml-2">
                            #{{ item.id_procedimento }}
                        </span>
                    </div>
                </div>

                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12" :class="setup ? '' 
                                : ( configdescr ? 'col-md-6' : 'col-md-10' )">
                            <az-input
                                label="Nome do Procedimento"
                                required
                                :validate="validate"
                                v-model="item.st_procedimento"/>
                        </div>
                        <div class="col col-12 col-md-4" v-if="!setup && configdescr">
                            <az-input
                                label="Descrição para o Paciente"
                                placeholder="Nome do Procedimento..."
                                :validate="validate"
                                v-model="item.st_nome_completo"/>
                        </div>
                        <div class="col col-12 col-md-1" v-if="!setup">
                            <az-input
                                label="Sigla"
                                :validate="validate"
                                v-model="item.st_sigla"/>
                        </div>
                        <div class="col col-12 col-md-1" v-if="!setup">
                            <az-input
                                label="Código Externo"
                                v-model="item.st_id_externo"
                                :validate="validate" />
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Especialidade"
                                type="select"
                                optionsMode="esp-ativas"
                                optionsName="esp-ativas"
                                optionsData="id_especialidade"
                                required
                                :validate="validate"
                                :edicao="!item.medico_procedimento_unidades_count"
                                v-model="item.id_especialidade" />
                        </div>
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Classificação"
                                type="select"
                                optionsData="id_classe_procedimento"
                                service="classe_procedimentos.index"
                                optionsMode="aql"
                                v-model="item.id_classe_procedimento"
                                required
                                :validate="validate"/>
                        </div>
                    </div>

                    <!-- Restrição para Paicentes -->
                    <div class="form-row">
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="number"
                                label="Idade Mínima"
                                placeholder="0"
                                v-model="item.in_paciente_idade_minima">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                            <span v-if="item.st_idade_medida == 'd'">dia(s)</span>
                                            <span v-else>ano(s)</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="item.st_idade_medida = 'd'">Dia(s)</a>
                                            <a class="dropdown-item" href="#" @click.prevent="item.st_idade_medida = 'a'">Ano(s)</a>
                                        </div>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="number"
                                label="Idade Máxima"
                                placeholder="999"
                                v-model="item.in_paciente_idade_maxima">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                            <span v-if="item.st_idade_medida == 'd'">dia(s)</span>
                                            <span v-else>ano(s)</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="item.st_idade_medida = 'd'">Dia(s)</a>
                                            <a class="dropdown-item" href="#" @click.prevent="item.st_idade_medida = 'a'">Ano(s)</a>
                                        </div>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="sexo"
                                placeholder="Qualquer"
                                label="Sexo do Paciente"
                                v-model="item.ch_paciente_sexo" />
                        </div>

                        <template v-if="item.id_classe_procedimento > 2 && !setup">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="select"
                                    optionsMode="aql"
                                    optionsData="id_status_laudo"
                                    service="status_laudos.index"
                                    placeholder="Sem fluxo de laudo"
                                    label="Fluxo de Laudo (Abertura)"
                                    v-model="item.id_status_laudo" />
                            </div>
                            <div class="col col-12 col-md-1">
                                <az-input
                                    type="number"
                                    placeholder="1..."
                                    label="Qtde Padrão"
                                    v-model="item.in_qtde_default" />
                            </div>
                        </template>
                    </div>

                    <template v-if="item.id_classe_procedimento >= 1 && !setup">
                        <div class="form-row mt-2">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Possui Pré-Atendimento"
                                    v-model="item.fl_pre_atendimento" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Impedir Chamada por Outro Atendimento"
                                    v-model="item.fl_tem_atendimento_previo" />
                            </div>

                            <div class="col col-12 col-md-3" v-if="item.id_classe_procedimento > 2">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Execução Simultânea"
                                    v-model="item.fl_simultaneo" />
                            </div>

                            <div class="col col-12 col-md-3" v-if="item.id_classe_procedimento > 2">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Zerado"
                                    v-model="item.fl_zerado" />
                            </div>
                        </div>
                    </template>
                    
                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-input
                                label="Código TUSS"
                                type="autocomplete"
                                service="sus-tuss.index"
                                optionsMode="aql"
                                optionsData="CO_TUSS"
                                :optionsExternal="true"
                                :validate="validate"
                                v-model="item.st_codigo_cbhpm">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="item.st_codigo_cbhpm && item.st_codigo_cbhpm.length == 8">
                                        <span class="input-group-text" id="basic-addon2">{{ item.st_codigo_cbhpm }}</span>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-6" v-if="$util.tem_sus() && !setup">
                            <az-input
                                label="Código SUS"
                                type="autocomplete"
                                service="sus-procedimentos.index"
                                optionsMode="aql"
                                optionsData="CO_PROCEDIMENTO"
                                :validate="validate"
                                v-model="item.st_codigo_sus">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="item.st_codigo_sus && item.st_codigo_sus.length == 10">
                                        <span class="input-group-text" id="basic-addon2">{{ item.st_codigo_sus }}</span>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </div>

                    <template v-if="!setup">

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Grupo"
                                    type="select"
                                    optionsData="id_procedimento_grupo"
                                    service="procedimento_grupos.index"
                                    optionsMode="aql"
                                    v-model="item.id_procedimento_grupo"
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input   
                                    placeholder="Não definida..."
                                    label="Duração Procedimento (Guia)"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_duracao">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <div class="input-group-text">
                                                min
                                            </div>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <template v-if="( item.id_especialidade == 2 || item.id_especialidade == 67 )">

                                <div class="col col-12 col-md-3" v-if="item.js_info && lista_consumo_procs.length">
                                    <az-input
                                        label="Curva / Tempos"
                                        type="number"
                                        placeholder="Quantidade de dosagens..."
                                        v-model="item.js_info.curva_tempos"
                                        :validate="validate" />
                                </div>

                                <div class="col col-12 col-md-3" v-if="item.id_status_laudo">
                                    <az-input
                                        label="Número de Ordem de Impresssão (Exames Laboratoriais)"
                                        type="number"
                                        placeholder="Lançamento..."
                                        v-model="item.in_lab_imp_ordem"
                                        :validate="validate" />
                                </div>

                            </template>

                            <template v-else-if="exibirModalidadeDicom">

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Modalidade DICOM"
                                        type="select"
                                        optionsData="id_modalidade_dicom"
                                        optionsName="st_descricao"
                                        service="modalidade_dicom.index"
                                        optionsMode="aql"
                                        v-model="item.id_modalidade_dicom" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        placeholder="Por Exame..."
                                        label="Grupo DICOM (Accession Number)"
                                        v-model="item.st_agrupa_dicom" />
                                </div>
                                
                            </template>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Não disponibilizar na fila do Consultório"
                                    v-model="item.fl_nao_consultorio" />
                            </div>

                            <template v-if="item.id_classe_procedimento > 2">

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="checkbox-group"
                                        label="Disponível para Requisição (PEP)"
                                        v-model="item.fl_ativo" />
                                </div>

                                <div class="col col-12" :class="item.id_classe_procedimento == 17 ? 'col-md-3' : 'col-md-6'">
                                    <az-input
                                        type="checkbox-group"
                                        label="Não exibir aba no consultório"
                                        v-model="item.fl_block_aba" />
                                </div>

                                <div class="col col-12 col-md-3" v-if="item.id_classe_procedimento == 17">
                                    <az-input
                                        type="checkbox-group"
                                        label="Informar data individual na guia"
                                        v-model="item.fl_info_data" />
                                </div>
                            </template>
                        </div>
                        
                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTagProc"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação selecionada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <!-- Campos Customizados -->
                        <div v-if="item.campos_customizados" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" :big="true" />
                                <formulario
                                    :gutters="true"
                                    :validate="validate"
                                    v-model="item.campos_customizados.js_campos"
                                    :saved="true"
                                    mode="fixed"
                                    :config="true" />
                            </div>
                        </div>

                    </template>

                    <hr>

                    <div class="row" v-if="item.id_procedimento && !setup">
                        <div class="col">

                            <div class="row">
                                <div class="col col-12 col-md-2 mb-3">
                                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                        <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">
                                            Tabelas

                                            <span class="badge badge-primary ml-2" v-if="!item.fl_zerado && tabelas">
                                                {{ tabelas.filter(item => item.procedimento_item_tabela && item.procedimento_item_tabela.item_tabela).length }}/{{ tabelas.length }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">
                                            Prestadores

                                            <span class="badge badge-primary ml-2" v-if="medicos">
                                                {{ medicos.filter(item => item.medico_procedimento_unidade && item.medico_procedimento_unidade.fl_ativo).length }}/{{ medicos.length }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false">
                                            Componentes
                                            <span class="badge badge-primary ml-2">
                                                {{ lista_consumo.length }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false">
                                            Instruções
                                            <span class="text-primary ml-2">
                                                <i class="fas fa-clipboard-check" aria-hidden="true" v-if="item.unidade_procedimento.instrucao.st_instrucao"></i>
                                                <i class="fas fa-user-check ml-1" aria-hidden="true" v-if="item.unidade_procedimento.instrucao.st_instrucao_agenda_online"></i>
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-modelos-tab" data-toggle="pill" href="#v-pills-modelos" role="tab" aria-controls="v-pills-modelos" aria-selected="false" v-if="item && item.id_procedimento">
                                            Modelos de Prontuário
                                        </a>
                                        <a class="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-sus" role="tab" aria-controls="v-pills-sus" aria-selected="false" v-if="item && $util.tem_sus()">
                                            SUS
                                        </a>
                                        <a class="nav-link" id="v-pills-colirios-tab" data-toggle="pill" href="#v-pills-colirios" role="tab" aria-controls="v-pills-colirios" aria-selected="false" v-if="item && $util.tem_sus() && item.st_codigo_sus && tem_colirio">
                                            Colírios
                                        </a>
                                        <a class="nav-link" id="v-pills-pag-tab" data-toggle="pill" href="#v-pills-pag" role="tab" aria-controls="v-pills-pag" aria-selected="false" v-if="item && pag_online">Pagamento Online</a>
                                        <a class="nav-link" id="v-pills-amostras-tab" data-toggle="pill" href="#v-pills-amostras" role="tab" aria-controls="v-pills-amostras" aria-selected="false" v-if="item && item.id_classe_procedimento > 2 && ( item.id_especialidade == 2 || item.id_especialidade == 67 || item.id_classe_procedimento == 20 )">
                                            Material da Amostra
                                            <span class="badge badge-primary ml-2">
                                                {{ lista_amostras.length }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-prazo-tab" data-toggle="pill" href="#v-pills-prazo" role="tab" aria-controls="v-pills-prazo" aria-selected="false" v-if="item && item.id_classe_procedimento > 2 && item.id_status_laudo">
                                            Prazo de Entrega
                                            <span class="text-primary ml-2">
                                                <i class="fa fa-check-circle" aria-hidden="true" v-if="item.in_prazo_entrega"></i>
                                                <i class="fa fa-question-circle" aria-hidden="true" v-else></i>
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-terceiro-tab" data-toggle="pill" href="#v-pills-terceiro" role="tab" aria-controls="v-pills-terceiro" aria-selected="false" v-if="item && item.id_classe_procedimento > 2 && terceiros && terceiros.length">
                                            Terceirizado
                                            <span class="badge badge-primary ml-2">
                                                {{ item.procedimento_terceiros.length }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-complemento-tab" data-toggle="pill" href="#v-pills-complemento" role="tab" aria-controls="v-pills-complemento" aria-selected="false" v-if="item && ( item.id_classe_procedimento != 1 )">
                                            Complemento
                                            <span class="badge badge-primary ml-2">
                                                {{ item.js_complementos ? item.js_complementos.length : 0 }}
                                            </span>
                                        </a>
                                        <a class="nav-link" id="v-pills-filtros-tab" data-toggle="pill" href="#v-pills-filtros" role="tab" aria-controls="v-pills-filtros" aria-selected="false" v-if="item && item.fl_tem_atendimento_previo">
                                            Outro Atendimento Prévio
                                            <span class="badge badge-primary ml-2">
                                                {{ item.filtros ? item.filtros.length : 0 }}
                                            </span>
                                        </a>

                                        <a class="nav-link" id="v-pills-cc-tab" data-toggle="pill" href="#v-pills-cc" role="tab" aria-controls="v-pills-cc" aria-selected="false" v-if="item">
                                            Centro de Custo
                                            <span class="badge badge-primary ml-2">
                                                {{ item.centro_custos ? item.centro_custos.length : 0 }}
                                            </span>
                                        </a>

                                        <a class="nav-link" id="v-pills-recursos-tab" data-toggle="pill" href="#v-pills-recursos" role="tab" aria-controls="v-pills-recursos" aria-selected="false" v-if="item && equipamentos && equipamentos.length">
                                            Recursos
                                            <span class="badge badge-primary ml-2">
                                                {{ item.procedimento_equipamentos ? item.procedimento_equipamentos.length : 0 }}
                                            </span>
                                        </a>

                                        <a class="nav-link" id="v-pills-especs-tab" data-toggle="pill" href="#v-pills-especs" role="tab" aria-controls="v-pills-especs" aria-selected="false">
                                            Outras Especialidades
                                            <span class="badge badge-primary ml-2" v-if="item.especs && item.especs.length > 0">
                                                {{ item.especs ? item.especs.length : 0 }}
                                            </span>
                                        </a>

                                        <template v-if="( item.id_especialidade == 2 || item.id_especialidade == 67 )">
                                            <a class="nav-link" id="v-pills-lab-tab" data-toggle="pill" href="#v-pills-lab" role="tab" aria-controls="v-pills-lab" aria-selected="false">
                                                Laboratório
                                            </a>
                                        </template>

                                        <template v-if="( item.id_classe_procedimento == 20 )">
                                            <a class="nav-link" id="v-pills-anat-tab" data-toggle="pill" href="#v-pills-anat" role="tab" aria-controls="v-pills-anat" aria-selected="false">
                                                Anatomia Patológica
                                            </a>
                                        </template>

                                        <a class="nav-link" id="v-pills-sin-tab" data-toggle="pill" href="#v-pills-sin" role="tab" aria-controls="v-pills-sin" aria-selected="false">
                                            Sinônimos
                                        </a>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-10">
                                    <div class="tab-content" id="v-pills-tabContent">
                                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">

                                            <div v-if="item.fl_zerado" class="alert alert-warning">
                                                Procedimento <strong>Zerado</strong>. Sem vínculos com tabelas de preços.
                                            </div>

                                            <template v-else>

                                                <!-- Tabelas -->
                                                <div class="mb-3">
                                                    <az-input 
                                                        icon="fa fa-search fa-fw" 
                                                        placeholder="Pesquisar..."
                                                        v-model="search_tabelas">
                                                        <template v-slot:buttonposb>
                                                            <div class="input-group-append" title="Vinculados vs Total">
                                                                <span class="input-group-text">
                                                                    {{ lista_tabelas.filter(item => item.procedimento_item_tabela.item_tabela).length }} / {{ lista_tabelas.length }}
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </az-input>

                                                    <button type="button" class="btn btn-sm btn-outline-primary mt-1" @click="vincular_tuss()" v-if="item.st_codigo_cbhpm" :disabled="$store.state.loading">
                                                        Vincular pelo Código TUSS
                                                    </button>
                                                </div>

                                                <template v-if="!vinculando">
                                                    <div class="form-row" v-for="(tabela, iti) in lista_tabelas" :key="iti">
                                                        <div class="col col-12 col-md-4">
                                                            <a href="#" class="form form-control text-primary card-link text-nowrap text-truncate d-inline-block"
                                                                data-toggle="tooltip" data-placement="top" :title="tabela.st_nome + ' - ' + tabela.st_versao"
                                                                @click.prevent="acessarTabela (tabela, tabela.procedimento_item_tabela.item_tabela)">
                                                                <small>
                                                                    {{ tabela.st_nome + ' - ' + tabela.st_versao }}
                                                                </small>
                                                            </a>
                                                        </div>
                                                        <div class="col col-12 col-md-8">
                                                            <az-input
                                                                type="autocomplete"
                                                                service="item_tabelas.index"
                                                                :optionsParm="{ id_tabela_versao: tabela.id_tabela_versao }"
                                                                optionsMode="aql"
                                                                v-model="tabela.procedimento_item_tabela.item_tabela"/>
                                                        </div>
                                                    </div>
                                                </template>

                                                <div v-if="!tabelas || !tabelas.length">
                                                    <az-empty-state msg="Nenhuma tabela registrada" />
                                                </div>

                                                <pre v-if="1 == 0">{{ tabelas }}</pre>

                                            </template>

                                        </div>

                                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">

                                            <!-- Prestadores -->
                                            <selecao-prestadores-procedimentos v-model="medicos" :id_procedimento="item.id_procedimento" @refresh="editar (item)" />

                                            <!--
                                            <button type="button" class="btn btn-outline-primary btn-sm mb-3" @click="marcar_todos_medicos()">
                                                Todos
                                            </button>

                                            <ul class="list-group">
                                                <li class="list-group-item" v-for="(medico, im) in medicos" :key="im">
                                                    <input class="mr-3" type="checkbox"
                                                        v-model="medico.medico_procedimento_unidade.fl_ativo"
                                                        id="defaultCheck1">
                                                    <label class="form-check-label" for="defaultCheck1">
                                                        <a href="#" class="card-link" @click.prevent="$util.abrirMedico (medico.medico)">
                                                            {{ medico.medico.search }}
                                                        </a>
                                                    </label>
                                                </li>
                                            </ul>

                                            <div v-if="!medicos || !medicos.length">
                                                <az-empty-state msg="Nenhuma médico registrado." />
                                            </div>

                                            <pre v-if="1 == 0">{{ medicos }}</pre>
                                            -->

                                        </div>

                                        <!-- Componentes -->

                                        <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">

                                            <template v-for="(comp, icx) in lista_consumo">
                                                <div class="form-row" :key="icx" v-if="true">
                                                    <div class="col col-12 col-md-6">
                                                        <az-input
                                                            sizing="sm"
                                                            icon="fa fa-minus fa-fw"
                                                            :buttonIcon="true"
                                                            buttonColor="outline-danger"
                                                            buttonText="fa fa-minus fa-fw"
                                                            @clickButton="comp.excluido = true"
                                                            :edicao="false"
                                                            v-model="comp.search">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append">

                                                                    <template v-if="item && item.id_classe_procedimento == 2">
                                                                        <div class="input-group-text" title="Porte Anestésico">P</div>
                                                                        <input style="max-width: 45px;" class="form form-control form-control-sm" type="number" v-model="comp.in_porte_anestesico" title="Porte Anestésico" placeholder="..." />
                                                                    </template>

                                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="comp.outro_medico = !comp.outro_medico"
                                                                        v-if="comp.id_procedimento_item"
                                                                        title="Definir o médico executante padrão">
                                                                        <i class="fa fa-user-md" aria-hidden="true"></i>
                                                                    </button>
                                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="comp.tem_filtros = !comp.tem_filtros"
                                                                        title="Filtro por sexo e/ou idade do paciente.">
                                                                        <i class="fa fa-filter" aria-hidden="true"></i>
                                                                    </button>
                                                                    
                                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="comp.fl_block_valor = !comp.fl_block_valor"
                                                                        :title="comp.fl_block_valor ? 'Procedimento sem valor' : 'Procedimento com valor'">
                                                                        <i class="fa-brands fa-creative-commons-nc fa-fw text-danger" v-if="comp.fl_block_valor"></i>
                                                                        <i class="fa-solid fa-dollar-sign fa-fw" v-else></i>
                                                                    </button>

                                                                    <button class="btn" :class="comp.fl_force_guia ? 'btn-outline-primary' : ' btn-outline-secondary'" 
                                                                        type="button" id="button-addon2" @click="comp.fl_force_guia = !comp.fl_force_guia"
                                                                        :title="comp.fl_force_guia ? 'Lançar na guia, mesmo sem valor' : 'Não forçar lançamento na guia.'"
                                                                        v-if="comp.fl_block_valor">
                                                                        <i class="fa-solid fa-file-circle-plus fa-fw" v-if="comp.fl_force_guia"></i>
                                                                        <i class="fa-solid fa-file-circle-xmark fa-fw" v-else></i>
                                                                    </button>

                                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="comp.fl_block_laudo = !comp.fl_block_laudo"
                                                                        v-if="comp.procedimento_item && comp.procedimento_item.id_status_laudo > 0"
                                                                        :title="comp.fl_block_laudo ? 'Procedimento sem laudo' : 'Procedimento com laudo'">
                                                                        <i class="fa-solid fa-play fa-fw" v-if="!comp.fl_block_laudo"></i>
                                                                        <i class="fa-solid fa-pause fa-fw text-danger" v-else></i>
                                                                    </button>

                                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="comp.fl_block_print = !comp.fl_block_print"
                                                                        v-if="comp.procedimento_item && comp.procedimento_item.id_status_laudo > 0 && item.id_especialidade == 2 && !comp.fl_block_laudo"
                                                                        :title="comp.fl_block_print ? 'Não imprimir laudo para o procedimento' : 'Imprimir laudo para o procedimento'">
                                                                        <i class="fa-solid fa-file-circle-check fa-fw" v-if="!comp.fl_block_print"></i>
                                                                        <i class="fa-solid fa-file-circle-xmark fa-fw text-danger" v-else></i>
                                                                    </button>

                                                                    <button class="btn" :class="( comp.js_unidades && comp.js_unidades.length ) ? 'btn-secondary' : 'btn-outline-secondary'" type="button" id="button-addon2" @click="selecao_comp_unidades(comp)" title="Seleção de unidades para o componente.">
                                                                        <i class="fa-regular fa-building"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>

                                                        <div v-if="comp.lista_unidades && ( comp.lista_unidades.length || comp.fl_unidades_regra )" class="small text-muted mb-1" title="Unidades">
                                                            <a href="#" @click.prevent="selecao_comp_unidades(comp)" class="card-link text-muted">
                                                                <i class="fa-solid fa-circle-plus mr-1" v-if="comp.fl_unidades_regra"></i>
                                                                <i class="fa-solid fa-circle-minus mr-1" v-else></i>
                                                                {{ comp.lista_unidades.map(und => und.st_sigla).join(', ') }}
                                                            </a>
                                                        </div>

                                                        <az-input
                                                            v-if="comp.outro_medico"
                                                            class="ml-5 mb-2"
                                                            sizing="sm"
                                                            icon="fa fa-user-md fa-fw"
                                                            type="autocomplete"
                                                            optionsMode="aql"
                                                            service="medico_procedimento_unidades.index"
                                                            optionsData="id_pessoa"
                                                            optionsDisplay="search"
                                                            :optionsParm="{
                                                                troca_em_procedimento: true,
                                                                id_procedimento: comp.id_procedimento_item,
                                                                id_especialidade: comp.procedimento_item.id_especialidade,
                                                            }"
                                                            required
                                                            :validate="validate"
                                                            v-model="comp.id_medico" />
                                                    </div>

                                                    <div class="col col-12 col-md-1">
                                                        <az-input
                                                            sizing="sm"
                                                            type="number"
                                                            :validate="validate"
                                                            :iconEnd="{
                                                                color: comp.consumo_procedimento_operadoras.length ? 'outline-primary' : 'outline-secondary',
                                                                icon: 'far fa-credit-card',
                                                                tooltip: 'Configurações de quantidade por operadora'
                                                            }"
                                                            @clickButtonEnd="configurarPorOperadora(comp)"
                                                            v-model="comp.dc_quantidade" />
                                                    </div>

                                                    <div class="col col-12 col-md-1">
                                                        <az-input
                                                            sizing="sm"
                                                            type="number"
                                                            :validate="validate"
                                                            v-model="comp.in_regra_ordem">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend" data-toggle="tooltip" title="Ordem">
                                                                    <span class="input-group-text" id="basic-addon1">
                                                                        <i class="fa-solid fa-sort"></i>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>

                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            label="Não Repetir"
                                                            type="checkbox-group"
                                                            labelClass="lead"
                                                            :validate="validate"
                                                            v-model="comp.fl_nao_repetir" />
                                                    </div>

                                                    <div class="col col-12 col-md-2" v-if="comp.fl_nao_repetir">
                                                        <az-input
                                                            sizing="sm"
                                                            label="Mesmo Procedimento"
                                                            type="checkbox-group"
                                                            labelClass="lead"
                                                            :validate="validate"
                                                            v-model="comp.fl_nao_repetir_mesmo_proc" />
                                                    </div>

                                                    <div class="col col-12 col-md-2" v-if="item.id_classe_procedimento == 18">
                                                        <az-input
                                                            icon="fa-regular fa-calendar-check"
                                                            sizing="sm"
                                                            placeholder="Todos os Ds..."
                                                            :validate="validate"
                                                            v-model="comp.st_ciclo_dias">
                                                        </az-input>
                                                    </div>
                                                </div>

                                                <div class="form-row mb-2" v-if="comp.procedimento_item && comp.procedimento_item.amostras && comp.procedimento_item.amostras.length > 1" :key="'FA' + icx">
                                                    <div class="col col-12 col-md-1">
                                                        &nbsp;
                                                    </div>

                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            sizing="sm"
                                                            icon="fas fa-vial"
                                                            type="select"
                                                            placeholde="Material..."
                                                            :optionsList="comp.procedimento_item.amostras"
                                                            optionsData="id_amostra_material"
                                                            v-model="comp.id_amostra_material" />
                                                    </div>
                                                </div>

                                                <div class="form-row mb-2" v-if="comp.tem_filtros" :key="'F' + icx">
                                                    <div class="col col-12 col-md-1">
                                                        &nbsp;
                                                    </div>

                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            label="De (Idade em Anos)"
                                                            type="number"
                                                            placeholde="De..."
                                                            v-model="comp.in_idade_min" />
                                                    </div>

                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            label="Até (Idade em Anos)"
                                                            type="number"
                                                            placeholde="Até..."
                                                            v-model="comp.in_idade_max" />
                                                    </div>

                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            label="Sexo"
                                                            type="select"
                                                            placeholder="Qualquer..."
                                                            optionsData="id"
                                                            :optionsList="[
                                                                { id: 'F', search: 'Feminino' },
                                                                { id: 'M', search: 'Masculino' }
                                                            ]"
                                                            v-model="comp.ch_sexo" />
                                                    </div>
                                                </div>

                                            </template>

                                            <div class="row mt-2">
                                                <div class="col">
                                                    <az-input
                                                        sizing="sm"
                                                        icon="fa fa-plus fa-fw"
                                                        label="Componente"
                                                        type="autocomplete"
                                                        optionsMode="aql"
                                                        optionsName="consumo.index"
                                                        :optionsParm="{ procedimentos: true, ativos: true }"
                                                        service="consumo.index"
                                                        :optionsSync="true"
                                                        v-model="novoComponente"
                                                        @input="incluirComponente ()" />
                                                </div>
                                            </div>

                                            <template v-if="lista_consumo && lista_consumo.length">

                                                <div class="row mt-2">
                                                    <div class="col">
                                                        <az-input
                                                                v-if="item.js_info"
                                                                class="mb-3"
                                                                sizing="sm"
                                                                type="checkbox-group"
                                                                label="Confirmar seleção dos componentes no lançamento"
                                                                v-model="item.js_info.conf_selec" />
                                                    </div>
                                                </div>

                                                <div class="alert alert-info" v-if="item.js_info && item.js_info.conf_selec">
                                                    Ao selecionar essa opção, ao realizar o lançamento do procedimento, será aberta uma tela para confirmação do lançamento do componentes.
                                                </div>

                                            </template>

                                            <button type="button" class="btn btn-outline-primary mt-3" v-if="lista_consumo.length"
                                                @click="clonar_componentes()">
                                                <i class="fas fa-copy mr-2"></i>
                                                Clonar Para
                                            </button>

                                        </div>

                                        <!-- Modal -->
                                        <div class="modal fade" id="consumoOperadoraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                                            <div class="modal-dialog modal-xl" role="document">
                                                <div class="modal-content" v-if="edicaoConsumoProcedimento">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title">Configurações por Operadora</h5>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <h5 class="text-primary">{{ edicaoConsumoProcedimento.search }}</h5>

                                                        <div class="form-row" v-for="(cpo, icpo) in lista_consumo_operadora" :key="icpo">
                                                            <div class="col col-12 col-md-8">
                                                                <az-input
                                                                    icon="fa fa-minus fa-fw"
                                                                    :buttonIcon="true"
                                                                    buttonColor="outline-danger"
                                                                    buttonText="fa fa-minus fa-fw"
                                                                    @clickButton="cpo.excluido = true"
                                                                    :edicao="false"
                                                                    v-if="cpo.id_plano"
                                                                    v-model="cpo.plano.search">
                                                                    <template v-slot:buttonposb>
                                                                        <div class="input-group-append">
                                                                            <span class="input-group-text" id="basic-addon2">P</span>
                                                                        </div>
                                                                    </template>
                                                                </az-input>

                                                                <az-input
                                                                    icon="fa fa-minus fa-fw"
                                                                    :buttonIcon="true"
                                                                    buttonColor="outline-danger"
                                                                    buttonText="fa fa-minus fa-fw"
                                                                    @clickButton="cpo.excluido = true"
                                                                    :edicao="false"
                                                                    v-else
                                                                    v-model="cpo.operadora.search">
                                                                    <template v-slot:buttonposb>
                                                                        <div class="input-group-append">
                                                                            <span class="input-group-text" id="basic-addon2">O</span>
                                                                        </div>
                                                                    </template>
                                                                </az-input>
                                                            </div>
                                                            <div class="col col-12 col-md-2">
                                                                <az-input
                                                                    label="Qtd"
                                                                    :compact="true"
                                                                    type="number"
                                                                    v-model="cpo.in_quantidade" />
                                                            </div>
                                                            <div class="col col-12 col-md-2">
                                                                <az-input
                                                                    label="R$"
                                                                    :compact="true"
                                                                    placeholder="Padrão..."
                                                                    type="number"
                                                                    v-model="cpo.dc_valor" />
                                                            </div>
                                                        </div>

                                                        <div class="row mt-2">
                                                            <div class="col">
                                                                <az-input
                                                                    type="button-group"
                                                                    :optionsList="[
                                                                        { id: 'O', search: 'Operadora' },
                                                                        { id: 'P', search: 'Particular' }
                                                                    ]"
                                                                    optionsData="id"
                                                                    optionsDisplay="search"
                                                                    v-model="novaOperadoraTipo" />
                                                            </div>
                                                        </div>

                                                        <div class="row mt-2" v-if="novaOperadoraTipo == 'O'">
                                                            <div class="col">
                                                                <az-input
                                                                    icon="fa fa-plus fa-fw"
                                                                    label="Operadora"
                                                                    type="autocomplete"
                                                                    optionsMode="aql"
                                                                    optionsName="operadoras.index"
                                                                    service="operadoras.index"
                                                                    :optionsSync="true"
                                                                    v-model="novaOperadora"
                                                                    @input="incluirOperadora ()" />
                                                            </div>
                                                        </div>

                                                        <div class="form-row mt-2" v-else-if="novaOperadoraTipo == 'P'">
                                                            <div class="col">
                                                                <az-input
                                                                    icon="fa fa-plus fa-fw"
                                                                    label="Particular"
                                                                    type="autocomplete"
                                                                    optionsMode="aql"
                                                                    optionsName="planos.particular.index"
                                                                    :optionsParm="{ particular: true }"
                                                                    service="planos.index"
                                                                    @input="incluirOperadoraPlano ()"
                                                                    v-model="novaOperadoraPlano" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                                        <button type="button" class="btn btn-success" @click="confirmarConfiguracaoPorOperadora ()">OK</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Instruções -->

                                        <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">

                                            <!-- Instruções -->
                                            <az-sub-title title="Instruções Internas">
                                                <a href="#" @click.prevent="preview_markdown(item.unidade_procedimento.instrucao, 'st_instrucao')" title="Preview">
                                                    <i class="fa-brands fa-markdown"></i>
                                                </a>
                                            </az-sub-title>
                                            <az-input type="textarea" v-model="item.unidade_procedimento.instrucao.st_instrucao" />
                                            
                                            <div class="form-row" v-if="item.unidade_procedimento.instrucao.st_instrucao">
                                                <div class="col col-12 col-md-4">
                                                    <az-input
                                                        type="checkbox-group"
                                                        sizing="sm"
                                                        label="Ciente na Recepção (Pop-Up)"
                                                        v-model="item.unidade_procedimento.instrucao.fl_ciente_recep" />
                                                </div>
                                                <div class="col col-12 col-md-4">
                                                    <az-input
                                                        type="checkbox-group"
                                                        sizing="sm"
                                                        label="Ciente no Orçamento (Pop-Up)"
                                                        v-model="item.unidade_procedimento.instrucao.fl_ciente_orc" />
                                                </div>
                                                <div class="col col-12 col-md-4" v-if="item.id_especialidade == 2">
                                                    <az-input
                                                        type="checkbox-group"
                                                        sizing="sm"
                                                        label="Ciente na Coleta (Pop-Up)"
                                                        v-model="item.unidade_procedimento.instrucao.fl_ciente_coleta" />
                                                </div>
                                                <div class="col col-12 col-md-4" v-else>
                                                    <az-input
                                                        type="checkbox-group"
                                                        sizing="sm"
                                                        label="Ciente na Agenda (Pop-Up)"
                                                        v-model="item.unidade_procedimento.instrucao.fl_ciente_agenda" />
                                                </div>
                                            </div>

                                            <az-sub-title class="mt-3" title="Instruções para o Paciente (E-mail, Agenda On-line, etc)">
                                                <a href="#" @click.prevent="preview_markdown(item.unidade_procedimento.instrucao, 'st_instrucao_agenda_online')" title="Preview">
                                                    <i class="fa-brands fa-markdown"></i>
                                                </a>
                                            </az-sub-title>
                                            <az-input type="textarea" v-model="item.unidade_procedimento.instrucao.st_instrucao_agenda_online" />

                                        </div>

                                        <!-- Pagamento Online -->

                                        <div class="tab-pane fade" id="v-pills-pag" role="tabpanel" aria-labelledby="v-pills-settings-pag">

                                            <div class="mt-3">

                                                <div class="row">
                                                    <div class="col col-12">
                                                        <az-input
                                                            type="checkbox-group"
                                                            label="Aceita Pagamento Online"
                                                            v-model="item.fl_pag_online" />
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        <!-- Modelos de Prontuário -->

                                        <div class="tab-pane fade" id="v-pills-modelos" role="tabpanel" aria-labelledby="v-pills-settings-modelos">

                                            <div v-for="(modelo, im) in modelos" :key="im">
                                                <div class="form-row">
                                                    <div class="col col-12">
                                                        <!-- 
                                                            icon="fa fa-minus fa-fw"
                                                            :buttonIcon="true"
                                                            buttonColor="outline-danger"
                                                            buttonText="fa fa-minus fa-fw"
                                                            @clickButton="modelo.excluido = true"
                                                        -->
                                                        <az-input
                                                            sizing="sm"
                                                            :edicao="false"
                                                            v-model="modelo.search">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        <router-link :to="{ path: '/modelos/' + modelo.id_modelo_prontuario }" class="card-link">
                                                                            #{{ modelo.id_modelo_prontuario }}
                                                                        </router-link>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="!modelos || !modelos.length">
                                                <az-empty-state msg="Nenhum modelo de prontuário registrado para esse procedimento." />
                                            </div>

                                        </div>

                                        <!-- SUS -->

                                        <div class="tab-pane fade" id="v-pills-sus" role="tabpanel" aria-labelledby="v-pills-settings-sus">

                                            <div v-if="item.sus_tb_procedimento">

                                                <template v-if="item.sus_tb_procedimento.registros && item.sus_tb_procedimento.registros.find(item => item.CO_REGISTRO == '06')">
                                                    <div class="form-row">
                                                        <div class="col col-12 col-md-4">
                                                            <az-input
                                                                sizing="sm"
                                                                label="Tipo de APAC"
                                                                type="select"
                                                                placeholder="Não definida..."
                                                                :optionsList="[
                                                                    { id: 1, search: 'Inicial' }, 
                                                                    { id: 3, search: 'Única' }, 
                                                                ]"
                                                                optionsData="id"
                                                                v-model="item.in_tipo_apac" />
                                                        </div>
                                                        <div class="col col-12 col-md-8">
                                                            <az-input   
                                                                sizing="sm"
                                                                placeholder="Não definido..."
                                                                label="Motivo de Saída Padrão"
                                                                type="select"
                                                                optionsMode="aql"
                                                                service="sus.motivo_saidas"
                                                                optionsData="id"
                                                                optionsDisplay="search"
                                                                :validate="validate"
                                                                v-model="item.st_sus_motivo_saida_padrao" />
                                                        </div>
                                                    </div>

                                                    <div class="form-row">
                                                        <div class="col col-12 col-md-4">
                                                            <az-input
                                                                sizing="sm"
                                                                label="Data de Saída"
                                                                type="select"
                                                                :optionsList="[
                                                                    { id: 1, search: 'Data de Atendimento' }, 
                                                                    { id: 0, search: 'Sem Valor Padrão' }, 
                                                                ]"
                                                                optionsData="id"
                                                                v-model="item.fl_apac_dt_alta" />
                                                        </div>
                                                        <div class="col col-12 col-md-8">
                                                            <az-input   
                                                                sizing="sm"
                                                                placeholder="Não definido..."
                                                                label="CID"
                                                                type="autocomplete"
                                                                optionsMode="aql"
                                                                service="cids.index"
                                                                optionsData="id_cid"
                                                                optionsDisplay="search"
                                                                :validate="validate"
                                                                v-model="item.id_cid" />
                                                        </div>
                                                    </div>
                                                </template>

                                                <div v-if="item.js_info && item.sus_tb_procedimento.registros">
                                                    <!-- && item.sus_tb_procedimento.registros.find(item => item.CO_REGISTRO == '01' || item.CO_REGISTRO == '02')"> -->
                                                    <div class="form-row">
                                                        <div class="col col-12 col-md-4">
                                                            <az-input
                                                                sizing="sm"
                                                                label="Serviço"
                                                                type="select"
                                                                :optionsList="item.sus_tb_procedimento.servicos"
                                                                optionsData="CO_SERVICO"
                                                                optionsDisplay="search"
                                                                v-model="item.js_info.sus_srv" />
                                                        </div>
                                                        <div class="col col-12 col-md-8">
                                                            <az-input
                                                                sizing="sm"
                                                                label="Classificação"
                                                                type="select"
                                                                :optionsList="lista_sus_clf"
                                                                optionsData="CO_CLASSIFICACAO"
                                                                optionsDisplay="search"
                                                                v-model="item.js_info.sus_clf" />
                                                        </div>
                                                    </div>

                                                    <div class="form-row" v-if="sus_tem_tipos && sus_tem_tipos.length > 1">
                                                        <div class="col col-12 col-md-4">
                                                            <az-input
                                                                sizing="sm"
                                                                label="Cobrar em..."
                                                                type="select"
                                                                :optionsList="sus_tem_tipos"
                                                                optionsData="id"
                                                                optionsDisplay="search"
                                                                v-model="item.js_info.tipo_guia" />
                                                        </div>

                                                        <div class="col col-12 col-md-4" v-if="item.js_info.tipo_guia == 'BPA'">
                                                            <az-input
                                                                sizing="sm"
                                                                label="BPA..."
                                                                placeholder="Padrão..."
                                                                type="select"
                                                                :optionsList="[
                                                                    { id: 'I', search: 'Individualizado' },
                                                                    { id: 'C', search: 'Consolidado' },
                                                                ]"
                                                                optionsData="id"
                                                                optionsDisplay="search"
                                                                v-model="item.js_info.tipo_bpa" />
                                                        </div>

                                                        <div class="col col-12 col-md-4">
                                                            <az-input
                                                                sizing="sm"
                                                                label="LEA de..."
                                                                type="select"
                                                                :optionsList="sus_tem_tipos"
                                                                optionsData="id"
                                                                optionsDisplay="search"
                                                                v-model="item.js_info.tipo_lea" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <table class="table table-hover mt-3">
                                                    <tbody>
                                                        <tr>
                                                            <td>Código</td>
                                                            <td>{{ item.sus_tb_procedimento.CO_PROCEDIMENTO }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Descrição</td>
                                                            <td>{{ item.sus_tb_procedimento.NO_PROCEDIMENTO }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Sexo:</td>
                                                            <td>{{ item.sus_tb_procedimento.sexo }}</td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.VL_IDADE_MINIMA != '9999'">
                                                            <td>Idade Mínima:</td>
                                                            <td>
                                                                {{ item.sus_tb_procedimento.VL_IDADE_MINIMA }}
                                                                <small class="text-muted">mes(es)</small>
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ idade_em_anos(item.sus_tb_procedimento.VL_IDADE_MINIMA) }}
                                                                <small class="text-muted">ano(s)</small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.VL_IDADE_MAXIMA != '9999'">
                                                            <td>Idade Máxima:</td>
                                                            <td>
                                                                {{ item.sus_tb_procedimento.VL_IDADE_MAXIMA }}
                                                                <small class="text-muted">mes(es)</small>
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ idade_em_anos(item.sus_tb_procedimento.VL_IDADE_MAXIMA) }}
                                                                <small class="text-muted">ano(s)</small>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Qtd Máxima:</td>
                                                            <td>{{ item.sus_tb_procedimento.QT_MAXIMA_EXECUCAO }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Competência:</td>
                                                            <td>{{ item.sus_tb_procedimento.DT_COMPETENCIA }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor SH:</td>
                                                            <td>{{ $util.formatMoeda(item.sus_tb_procedimento.VL_SH / 100) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor SA:</td>
                                                            <td>{{ $util.formatMoeda(item.sus_tb_procedimento.VL_SA / 100) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Valor SP:</td>
                                                            <td>{{ $util.formatMoeda(item.sus_tb_procedimento.VL_SP / 100) }}</td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.registros && item.sus_tb_procedimento.registros.length">
                                                            <td>Registros:</td>
                                                            <td>
                                                                <div v-for="(reg, irx) in item.sus_tb_procedimento.registros" :key="irx">
                                                                    {{ reg.CO_REGISTRO }} / {{ reg.NO_REGISTRO }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.ocupacoes && item.sus_tb_procedimento.ocupacoes.length">
                                                            <td>CBOs:</td>
                                                            <td>
                                                                <div v-for="(item, idx) in item.sus_tb_procedimento.ocupacoes" :key="idx">
                                                                    {{ item.CO_OCUPACAO }} / {{ item.NO_OCUPACAO }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.cids && item.sus_tb_procedimento.cids.length">
                                                            <td>CIDs:</td>
                                                            <td>
                                                                <span class="badge badge-secondary mb-1 mr-1"
                                                                    v-for="(cid, icx) in item.sus_tb_procedimento.cids" :key="icx">
                                                                    {{ cid.CO_CID }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="item.sus_tb_procedimento.servicos && item.sus_tb_procedimento.servicos.length">
                                                            <td>Serviços:</td>
                                                            <td>
                                                                <div
                                                                    v-for="(item, idx) in item.sus_tb_procedimento.servicos" :key="idx">
                                                                    {{ item.CO_SERVICO }} / {{ item.NO_SERVICO }}
                                                                    <ul>
                                                                        <li v-for="(subitem, isx) in item.classificacoes" :key="idx + isx">
                                                                            {{ subitem.CO_CLASSIFICACAO}} / {{ subitem.NO_CLASSIFICACAO}}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>


                                                <pre v-if="1 == 0" class="mt-3 alert-warning">{{ item.sus_tb_procedimento }}</pre>

                                            </div>

                                        </div>

                                        <!-- SUS -->

                                        <div class="tab-pane fade" id="v-pills-colirios" role="tabpanel" aria-labelledby="v-pills-colirios-sus">

                                            <div class="mt-3">
                                                <ul class="list-group" v-if="item.medicamento_cobrancas">
                                                    <template v-for="(medcob, imx) in item.medicamento_cobrancas">
                                                        <li class="list-group-item" :key="imx" v-if="!medcob.excluido">
                                                            <a href="#" @click.prevent="medcob.excluido = true" class="mr-3">
                                                                <i class="fas fa-trash-alt text-danger"></i>
                                                            </a>
                                                            {{ medcob.medicamento.search }}
                                                        </li>
                                                    </template>

                                                    <div class="row mt-2">
                                                        <div class="col">
                                                            <az-input
                                                                sizing="sm"
                                                                icon="fa fa-plus fa-fw"
                                                                label="Colírio..."
                                                                type="autocomplete"
                                                                optionsMode="aql"
                                                                optionsName="medicamentos.index"
                                                                :optionsParm="{ pep: true }"
                                                                service="medicamentos.index"
                                                                :optionsSync="true"
                                                                v-model="novoColirio"
                                                                @input="incluir_colirio ()" />
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>

                                        </div>

                                        <!-- Material das Amostras -->

                                        <div class="tab-pane fade" id="v-pills-amostras" role="tabpanel">

                                            <button class="btn btn-outline-success" @click="incluir_material(item)">
                                                Incluir Material
                                            </button>

                                            <ul class="list-group mt-3">
                                                <li class="list-group-item d-flex justify-content-between" v-for="(amostra, iax) in lista_amostras" :key="iax">
                                                    <div>
                                                        <i class="fa fa-check-circle text-success mr-2" aria-hidden="true" v-if="amostra.fl_padrao"></i>
                                                        <a href="#" @click.prevent="editar_material(amostra)" class="card-link">
                                                            {{ amostra.amostra_material.search }}
                                                        </a>
                                                        <span class="badge badge-secondary ml-2">
                                                            {{ amostra.in_regra_ordem }}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span class="badge badge-danger mr-2" v-if="amostra.amostra_material && !amostra.amostra_material.fl_ativo">Inativo</span>
                                                        <span class="badge badge-secondary">#{{ amostra.id_amostra_material }}</span>
                                                    </div>
                                                </li>
                                            </ul>

                                        </div>

                                        <!-- Prazo de Entrega -->

                                        <div class="tab-pane fade" id="v-pills-prazo" role="tabpanel">

                                            <div class="my-3">
                                                <div class="row">
                                                    <div class='col col-12 col-md-6'>
                                                        <az-input
                                                            type="number"
                                                            label="Prazo"
                                                            v-model="item.in_prazo_entrega" />
                                                    </div>
                                                    <div class='col col-12 col-md-6' v-if="item.in_prazo_entrega">
                                                        <az-input
                                                            type="select"
                                                            label="Referência do Prazo"
                                                            placeholder="Selecione..."
                                                            optionsData="id"
                                                            :optionsList="[
                                                                { id: 'days', search: 'dias' },
                                                                { id: 'hours', search: 'horas' },
                                                            ]"
                                                            :validate="validate"
                                                            v-model="item.st_tempo_prazo_entrega" />
                                                    </div>
                                                </div>
                                            </div>

                                            <cadastro-procedimento-prazo :procedimento="item" @refresh="refresh_prazos" />
                                        </div>

                                        <!-- Terceirizado -->

                                        <div class="tab-pane fade" id="v-pills-terceiro" role="tabpanel">

                                            <button class="btn btn-outline-success" @click="incluir_terceiro(item)">Incluir Terceiro</button>

                                            <table class="table table-hover mt-3">
                                                <tbody>
                                                    <tr v-for="(proced_terc, iptx) in item.procedimento_terceiros" :key="iptx">
                                                        <td>
                                                            <a href="#" @click.prevent="editar_terceiro(proced_terc)">
                                                                {{ proced_terc.terceiro.search }}
                                                            </a>
                                                        </td>
                                                        <td>
                                                            {{ proced_terc.st_codigo_terceiro }}
                                                            <span v-if="proced_terc.st_material_terceiro">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                {{ proced_terc.st_material_terceiro }}
                                                            </span>
                                                            <div v-if="proced_terc.amostra">
                                                                <span class="small text-muted">
                                                                    {{ proced_terc.amostra.search }}
                                                                </span>
                                                                <span class="badge badge-secondary ml-2">#{{ proced_terc.amostra.id_amostra_material }}</span>
                                                                <span class="badge badge-danger ml-2" v-if="proced_terc.amostra && !proced_terc.amostra.fl_ativo">Inativo</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <i class="fa fa-check-circle text-success mr-2" aria-hidden="true" v-if="proced_terc.fl_ativo"></i>
                                                            <i class="fa fa-filter " aria-hidden="true" v-if="proced_terc.filtros.length"></i>
                                                            <span class="badge badge-secondary ml-2">
                                                                {{ proced_terc.in_regra_ordem }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <template v-if="proced_terc.js_classes">
                                                                <span class="badge badge-success mr-1" v-for="(classe, icx) in proced_terc.js_classes" :key="icx">
                                                                    {{ classe }}
                                                                </span>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <!-- Modal -->
                                            <div class="modal fade" id="terceiroModal2" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                                                <div class="modal-dialog modal-xl" role="document">
                                                    <div class="modal-content" v-if="terceiro">
                                                        <div class="modal-header">
                                                            <h5 class="modal-title">Terceirizado</h5>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                                <span aria-hidden="true">&times;</span>
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <div class="row">
                                                                <div class="col col-12 col-md-10">
                                                                    <az-input
                                                                        label="Terceiro"
                                                                        type="select"
                                                                        required
                                                                        :validate="validate"
                                                                        :optionsList="terceiros"
                                                                        optionsData="id_terceiro"
                                                                        optionsDisplay="search"
                                                                        v-model="terceiro.id_terceiro" />
                                                                </div>

                                                                <div class="col col-12 col-md-2">
                                                                    <az-input
                                                                        label="Ordem"
                                                                        required
                                                                        :validate="validate"
                                                                        v-model="terceiro.in_regra_ordem" />
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col col-12">
                                                                    <az-input
                                                                        label="Material"
                                                                        placeholder="Qualquer Material..."
                                                                        type="select"
                                                                        optionsData="id_amostra_material"
                                                                        service="amostra_materiais.index"
                                                                        optionsMode="aql"
                                                                        v-model="terceiro.id_amostra_material"
                                                                        :validate="validate" />
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col col-12 " :class="is_shift ? 'col-md-3' : 'col-md-6'">
                                                                    <az-input
                                                                        label="Código do Exame"
                                                                        required
                                                                        :validate="validate"
                                                                        v-model="terceiro.st_codigo_terceiro" />
                                                                </div>
                                                                <div class="col col-12 col-md-3" v-if="is_shift">
                                                                    <az-input
                                                                        label="Código Mnemonico do exame"
                                                                        required
                                                                        :validate="validate"
                                                                        v-model="terceiro.st_mnemonico" />
                                                                </div>
                                                                <div class="col col-12 col-md-6">
                                                                    <az-input
                                                                        label="Código do Material"
                                                                        placeholder="Selecionado no Atendimento..."
                                                                        :validate="validate"
                                                                        v-model="terceiro.st_material_terceiro" />
                                                                </div>
                                                            </div>
                                                            <div class="row mt-3">
                                                                <div class="col col-12">
                                                                    <az-input
                                                                        label="Ativo"
                                                                        type="checkbox-group"
                                                                        v-model="terceiro.fl_ativo" />
                                                                </div>
                                                            </div>
                                                            <!-- Filtros -->
                                                            <filtro-model class="my-3" v-model="terceiro.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                                                        </div>
                                                        <div class="modal-footer">
                                                            <az-submit color="danger" @click="remover_terceiro()" v-if="terceiro.id_procedimento_terceiro">Remover</az-submit>
                                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                                            <az-submit @click="salvar_terceiro()">Atualizar</az-submit>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <!-- Complemento -->

                                        <div class="tab-pane fade" id="v-pills-complemento" role="tabpanel">

                                            <div class="alert alert-info">
                                                Caso o procedimento possa ser realizada em diferentes regiões do corpo, listar as possíveis regiões para diferenciar no momento do lançamento.
                                            </div>

                                            <multiselect
                                                v-if="item.js_complementos"
                                                v-model="item.js_complementos"
                                                :options="item.js_complementos"
                                                :multiple="true"
                                                :taggable="true"
                                                @tag="addTag"
                                                placeholder="Selecione uma região..."
                                                selectLabel="Pressione [ENTER] para selecionar"
                                                deselectLabel="Pressione [ENTER] para remover"
                                                tagPlaceholder="Pressione [ENTER] para incluir"
                                                selectedLabel="Selecionado">
                                                <template slot="noOptions">
                                                    Nenhuma região selecionado.
                                                </template>
                                            </multiselect>

                                        </div>

                                        <!-- Centro de Custo -->

                                        <div class="tab-pane fade" id="v-pills-cc" role="tabpanel" aria-labelledby="v-pills-cc-tab">

                                            <template v-for="(centro, icx) in item.centro_custos">
                                                <div class="form-row" :key="icx" v-if="!centro.excluido">
                                                    <div class="col col-12 col-md-6">
                                                        <az-input  
                                                            placeholder="Unidade..."
                                                            :label="icx ? '' : 'Unidade'"
                                                            sizing="sm"
                                                            type="select"
                                                            :optionsList="$util.unidades_com_tags(false,false)"
                                                            required
                                                            :validate="validate"
                                                            optionsData="id_unidade_operacao"
                                                            v-model="centro.id_unidade_operacao">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="centro.excluido = true">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                    <div class="col col-12 col-md-6" v-if="centro.id_unidade_operacao">
                                                        <az-input  
                                                            placeholder="Centro de Custo..."
                                                            :label="icx ? '' : 'Centro de Custo'"
                                                            sizing="sm"
                                                            type="select"
                                                            :optionsList="$util.unidade_operacao(centro.id_unidade_operacao)
                                                                ? $util.unidade_operacao(centro.id_unidade_operacao).centro_custos
                                                                : []"
                                                            required
                                                            :validate="validate"
                                                            optionsData="id_centro_custo"
                                                            v-model="centro.id_centro_custo">
                                                        </az-input>
                                                    </div>
                                                </div>
                                            </template>

                                            <button type="button" class="btn btn-sm btn-outline-primary mt-2" @click="incluir_centro_custo()">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>

                                            <hr>
                                        
                                            <az-input
                                                label="Categoria Financeira"
                                                sizing="sm"
                                                type="select"
                                                optionsMode="aql"
                                                optionsName="categorias.lancamento.entradas"
                                                :optionsParm="{ lancamento: true, where: { ch_natureza: 'C' } }"
                                                :optionsSync="true"
                                                service="categorias.index" 
                                                optionsData="id_categoria"
                                                v-model="item.id_categoria">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="item.id_categoria">
                                                        <span class="input-group-text">
                                                            #{{ item.id_categoria }}
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>

                                        </div>

                                        <!-- Recursos -->

                                        <div class="tab-pane fade" id="v-pills-recursos" role="tabpanel" aria-labelledby="v-pills-recursos-tab">

                                            <div>
                                                <az-input
                                                    class="mb-3"
                                                    sizing="sm"
                                                    type="select"
                                                    label="Necessita agendar recursos para execução"
                                                    placeholder="Selecione..."
                                                    :optionsList="[
                                                        { id: 0, search: 'Não necessita' }, 
                                                        { id: 1, search: 'Necessita agendar recursos para execução' },
                                                        { id: 2, search: 'Necessita agendar com um recurso pelo menos' },
                                                        { id: 3, search: 'Necessita agendar com um recurso dos listados abaixo' },
                                                    ]"
                                                    optionsData="id"
                                                    v-model="item.fl_recurso" />

                                                <template  v-if="item.fl_recurso">

                                                    <template v-for="(pe, iex) in item.procedimento_equipamentos">
                                                        <div class="form-row" :key="iex" v-if="!pe.excluido">
                                                            <div class="col col-12 col-md-4" v-if="false">
                                                                <az-input
                                                                    type="select"
                                                                    sizing="sm"
                                                                    :optionsList="[
                                                                        { id: 'C', search: 'Classe de Recurso' },
                                                                        { id: 'E', search: 'Recurso Específico' },
                                                                    ]"
                                                                    optionsData="id"
                                                                    :edicao="!pe.id_procedimento_equipamento"
                                                                    required
                                                                    :validate="validate"
                                                                    v-model="pe.st_tipo">
                                                                    <template v-slot:button-pre>
                                                                        <div class="input-group-prepend">
                                                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="pe.excluido = true">
                                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </template>
                                                                </az-input>
                                                            </div>
                                                            <div class="col col-12 col-md-9"> <!-- col-md-8 -->
                                                                <az-input
                                                                    sizing="sm"
                                                                    v-if="pe.st_tipo == 'C'"
                                                                    type="select"
                                                                    :optionsList="lista_classes_recurso"
                                                                    optionsData="id"
                                                                    :edicao="!pe.id_procedimento_equipamento"
                                                                    required
                                                                    :validate="validate"
                                                                    v-model="pe.st_classe" />

                                                                <az-input
                                                                    sizing="sm"
                                                                    v-else-if="pe.st_tipo == 'E' && equipamentos"
                                                                    type="select"
                                                                    :optionsList="equipamentos"
                                                                    optionsData="id_equipamento"
                                                                    :edicao="!pe.id_procedimento_equipamento"
                                                                    required
                                                                    :validate="validate"
                                                                    v-model="pe.id_equipamento">
                                                                    <template v-slot:button-pre>
                                                                        <div class="input-group-prepend">
                                                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="pe.excluido = true">
                                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                                            </button>
                                                                        </div>
                                                                    </template>
                                                                </az-input>
                                                            </div>
                                                            <div class="col col-12 col-md-3" v-if="item.fl_recurso == 1">
                                                                <az-input   
                                                                    sizing="sm"
                                                                    type="checkbox-group"
                                                                    label="Fixo"
                                                                    v-model="pe.fl_fixo" />
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <button type="button" class="btn btn-sm btn-outline-primary mt-2" @click="incluir_recurso()">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>

                                                </template>
                                            </div>

                                        </div>

                                        <!-- Especialidades -->

                                        <div class="tab-pane fade" id="v-pills-especs" role="tabpanel" aria-labelledby="v-pills-especs-tab">

                                            <template v-for="(espec, icx) in item.especs">
                                                <div class="form-row" :key="icx" v-if="!espec.excluido">
                                                    <div class="col col-12">
                                                        <az-input  
                                                            v-if="espec.id_procedimento_especialidade"
                                                            :label="icx ? '' : 'Especialidade'"
                                                            sizing="sm"
                                                            :edicao="false"
                                                            v-model="espec.especialidade.search">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="espec.excluido = true">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>

                                                        <az-input
                                                            v-else
                                                            :label="icx ? '' : 'Especialidade'"
                                                            type="select"
                                                            optionsMode="esp-ativas"
                                                            optionsName="esp-ativas"
                                                            optionsData="id_especialidade"
                                                            required
                                                            :validate="validate"
                                                            v-model="espec.id_especialidade" />
                                                    </div>
                                                </div>
                                            </template>

                                            <div>
                                                <button type="button" class="btn btn-sm btn-outline-primary mt-2" @click="incluir_espec()">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>

                                                <button type="button" class="btn btn-sm btn-outline-primary mt-2 ml-2" v-if="item.especs.filter(espec => !espec.excluido).length" @click="clonar_especialidades()">
                                                    <i class="fas fa-copy mr-2"></i>
                                                    Clonar Para
                                                </button>
                                            </div>

                                        </div>

                                        <!-- Laboratório -->

                                        <div class="tab-pane fade" id="v-pills-lab" role="tabpanel" aria-labelledby="v-pills-lab-tab">

                                            <div>
                                                <az-input
                                                    class="mb-1"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Não imprimir etiqueta para coleta"
                                                    v-model="item.fl_block_etq" />
                                            </div>

                                            <div v-if="item.js_info">
                                                <az-input
                                                    class="mb-1"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Não imprimir no espelho de atendimento"
                                                    v-model="item.js_info.block_esp" />
                                            </div>

                                            <div>
                                                <az-input
                                                    v-if="item.js_info"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Não cancelar se procedimento gerador estiver ativo"
                                                    v-model="item.js_info.block_canc" />
                                            </div>

                                            <div>
                                                <az-input
                                                    v-if="item.js_info"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Não permitir solicitar urgência"
                                                    v-model="item.js_info.block_urg" />
                                            </div>

                                            <div>
                                                <az-input
                                                    v-if="item.js_info"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Permitir lançar o mesmo material mais de uma vez"
                                                    v-model="item.js_info.lib_dup" />
                                            </div>

                                            <div v-if="item.js_info && item.js_classes && item.js_classes.find(classe => classe == 'comparativo')">
                                                <az-input
                                                    class="mb-1"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Laudo Genético Comparativo Familiar"
                                                    v-model="item.js_info.comparativo" />
                                            </div>

                                            <div class="form-row mt-3">
                                                <div class="col col-12 col-md-4">
                                                    <az-input
                                                        sizing="sm"
                                                        label="Sigla Etiqueta"
                                                        placeholder="Sigla Padrão"
                                                        v-model="item.st_sigla_etq" />
                                                </div>
                                            </div>

                                            

                                        </div>

                                        <!-- Anatomia Patológica -->

                                        <div class="tab-pane fade" id="v-pills-anat" role="tabpanel" aria-labelledby="v-pills-anat-tab">

                                            <div v-if="item.js_info">
                                                <az-input
                                                    class="mb-1"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Imuno Histoquímica"
                                                    v-model="item.js_info.ih" />
                                            </div>

                                            <div v-if="item.js_info">
                                                <az-input
                                                    class="mb-1"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Coloração"
                                                    v-model="item.js_info.color" />
                                            </div>

                                        </div>

                                        <!-- Sinônimos -->

                                        <div class="tab-pane fade" id="v-pills-sin" role="tabpanel" aria-labelledby="v-pills-sin-tab" v-if="item.sinonimos">

                                            <div v-for="(sinonimo, isx) in item.sinonimos" :key="isx">
                                                <div class="form-row" v-if="sinonimo.fl_ativo">
                                                    <div class="col col-12">
                                                        <az-input
                                                            type="text"
                                                            placeholder="Sinônimo..."
                                                            required
                                                            :validate="validate"
                                                            v-model="sinonimo.st_descricao">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="sinonimo.fl_ativo = false">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                </div>
                                            </div>

                                            <button type="button" class="btn btn-outline-primary" @click="incluir_sinonimo()">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>

                                        </div>

                                        <!-- Filtros -->

                                        <div class="tab-pane fade" id="v-pills-filtros" role="tabpanel" aria-labelledby="v-pills-filtros-tab">

                                            <div class="alert alert-info">
                                                Definir as condições para que a chamada para o atendimento seja impedida, até que o outro procedimento seja finalizado.
                                            </div>

                                            <filtro-model v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro_atend" />

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
				</div>
            </div>

            <pre v-if="false">{{ item }}</pre>

            <br><br><br>

            <!-- Botões de Atualização -->

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="item">
                <div>
                    <az-submit class="mr-2" @click="atualizar ()">{{ !item.id_procedimento ? 'Incluir' : 'Atualizar' }}</az-submit>
                    <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                    <button class="btn btn-outline-danger mr-2" @click="remover ()" v-if="1 == 0 && item.id_procedimento">Remover</button>
                    <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('procedimento', item.id_procedimento)"
                        v-if="item.id_procedimento && !setup">
                        Log
                    </button>
                    <button class="btn btn-outline-primary mr-2" @click="incluir_procedimento ()" v-if="item.id_procedimento">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-outline-primary mr-2" @click="clonar_procedimento ()" v-if="item.id_procedimento" title="Clonar">
                        <i class="fa-solid fa-clone"></i>
                    </button>
                </div>
            </nav>

        </div>

        <cadastro-item-tabela ref="cadtab" />

        <!-- Amostra Material Modal -->
        <div class="modal fade" id="amostraModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="amostra">
                    <div class="modal-header">
                        <h5 class="modal-title">Material da Amostra</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            label="Material"
                            type="select"
                            optionsData="id_amostra_material"
                            service="amostra_materiais.index"
                            optionsMode="aql"
                            v-model="amostra.id_amostra_material"
                            required
                            :validate="validate" />

                        <az-input
                            class="mt-3"
                            label="Padrão"
                            type="checkbox-group"
                            v-model="amostra.fl_padrao"
                            :validate="validate" />

                        <az-input
                            label="Ordem"
                            type="number"
                            required
                            :validate="validate"
                            v-model="amostra.in_regra_ordem" />
                    </div>
                    <div class="modal-footer">
                        <az-submit class="ml-2" @click="remover_material(amostra)" color="danger" v-if="amostra.id_procedimento_amostra_material">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit class="mr-2" @click="atualizar_material ()">{{ !amostra.id_procedimento_amostra_material ? 'Incluir' : 'Atualizar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Laudo -->
        <div class="modal fade" id="infoLaudoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Laudo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    optionsMode="aql"
                                    optionsData="id_status_laudo"
                                    service="status_laudos.index"
                                    placeholder="Sem fluxo de laudo"
                                    label="Fluxo de Laudo (Abertura)"
                                    v-model="info.id_status_laudo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Modalidade DICOM"
                                    type="select"
                                    optionsData="id_modalidade_dicom"
                                    optionsName="st_descricao"
                                    service="modalidade_dicom.index"
                                    optionsMode="aql"
                                    v-model="info.id_modalidade_dicom" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    label="Definir Prazo de Entrega"
                                    type="checkbox-group"
                                    v-model="info.definir_prazo" />
                            </div>
                        </div>

                        <div class="row mt-3" v-if="info.definir_prazo">
                            <div class="col col-12">
                                <az-input
                                    label="Prazo"
                                    type="number"
                                    v-model="info.prazo">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text">dia(s)</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_laudo()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <procedimento-lista ref="proclista" />
        <terceiro-de-para ref="depara" origem="procedimento" @refresh="editar (item)" />
        <preview-mark-down ref="markdown" />
        <selecao-unidades ref="selunid" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import CadastroItemTabela from '../shared/CadastroItemTabela.vue';
import AzLoading from '../../util/AzLoading.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import Importacao from '../shared/Importacao.vue';
import ProcedimentoLista from '../../shared/ProcedimentoLista.vue';
import SelecaoPrestadoresProcedimentos from '../shared/SelecaoPrestadoresProcedimentos.vue';
import Multiselect from 'vue-multiselect';
import TerceiroDePara from '../shared/TerceiroDePara.vue';
import PreviewMarkDown from '../../shared/PreviewMarkDown.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import SelecaoUnidades from '../shared/SelecaoUnidades.vue';
import CadastroProcedimentoPrazo from './CadastroProcedimentoPrazo.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data () {
        return {
            especialidade: "",
            classificacao: "", 
            search: "",
            filtro_material: 'T', 
            dados: null,
            em_edicao: false,
            item: null,
            tabelas: null,
            medicos: null,
            validate: false,
            viewMode: 'A',
            novoComponente: null,
            novaOperadora: null,
            consumoProcedimento: null,
            edicaoConsumoProcedimento: null,
            link: false,
            busca_procedimento: null,
            config: null,
            novaOperadoraTipo: 'O',
            novaOperadoraPlano: null,
            terceiros: [],
            terceiro: null,
            amostra: null,
            pesquisar_debounce: null,
            canceltoken: null,
            page: 1,
            list_mult: [],
            configdescr: false, 
            novoColirio: "", 
            info: { 
                id_status_laudo: "",
                id_modalidade_dicom: "", 
                definir_prazo: false, 
                prazo: "", 
            },
            search_tabelas: "", 
            vinculando: false, 
            equipamentos: null, 
            options_classes: [],
            modelos: [], 
        }
    },

    props: ['id_procedimento', 'setup'],

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubmit,
        CadastroItemTabela,
        AzLoading,
        FiltroModel,
        Importacao,
        ProcedimentoLista,
        SelecaoPrestadoresProcedimentos,
        Multiselect,
        TerceiroDePara, 
        PreviewMarkDown,
        AzSubTitle, 
        SelecaoUnidades, 
        CadastroProcedimentoPrazo, 
        Formulario, 
    },

    watch: {
        especialidade: function () {
            this.load ();
        }
    },

    computed: {
        sus_tem_tipos: function () { 
            if ( !this.item || !this.item.sus_tb_procedimento || !this.item.sus_tb_procedimento.registros )
                return false;

            let tipos = [];

            tipos['01'] = 'BPA';
            tipos['02'] = 'BPA';
            tipos['03'] = 'AIH';
            tipos['04'] = 'AIH';
            tipos['06'] = 'APAC';

            let disp = _.uniq(
                this.item.sus_tb_procedimento.registros.filter(item => tipos[item.CO_REGISTRO])
                    .map(item => tipos[item.CO_REGISTRO])
            );

            let lista = [
                'AIH',
                'APAC', 
                'BPA',
            ];

            return lista.map(item => {
                return { 
                    id: item, 
                    search: item + ( !disp.includes(item) ? ' (não presente na SigTap)' : '' ), 
                    fl_disp: disp.includes(item),
                };
            });

            /*
            return _.uniq(
                    this.item.sus_tb_procedimento.registros.filter(item => tipos[item.CO_REGISTRO])
                        .map(item => tipos[item.CO_REGISTRO])
                )
                .sort()
                .map(item => { 
                    return { 
                        id: item,
                        search: item,
                    };
                });
            */
        },

        lista_classes_recurso: function () { 
            if ( !this.equipamentos ) { 
                return [];
            }

            return _.uniq(
                    this.equipamentos.filter(item => item.js_classes)
                        .flatMap(item => item.js_classes)
                )
                .sort()
                .map(item => { 
                    return { 
                        id: item,
                        search: item,
                    };
                });
        },

        lista_sus_clf: function () { 
            if ( !this.item || !this.item.js_info || !this.item.js_info.sus_srv ) 
                return [];

            let servico = this.item.sus_tb_procedimento.servicos.find(item => item.CO_SERVICO == this.item.js_info.sus_srv);
            
            return servico ? servico.classificacoes : [];
        },

        tem_colirio: function () { 
            if ( !this.item || !this.item.st_codigo_sus || !this.item.sus_tb_procedimento )
                return false;

            if ( 
                ( this.item.sus_tb_procedimento.ocupacoes.length == 1 
                && this.item.sus_tb_procedimento.ocupacoes[0].CO_OCUPACAO == '225265' ) &&
                ( this.item.sus_tb_procedimento.registros.length == 1 
                && this.item.sus_tb_procedimento.registros[0].CO_REGISTRO == '07' ) 
            ) { 

                return true;

            }

            return false;
        },

        is_shift: function() {
            if(this.terceiros && this.terceiro && this.terceiro.id_terceiro) {
                const shift = _.find(this.terceiros, {id_terceiro: this.terceiro.id_terceiro});

                return (shift && shift.st_terceiro && shift.st_terceiro.toUpperCase() == 'SHIFT');
            }

            return false;
        },

        service_importacao: function () {
            return 'procedimentos';
        },

        pag_online: function () {
            return this.$store.state.unidade.parametro_unidade.fl_pag_online;
        },

        lista_consumo_procs: function () { 
            return this.lista_consumo.filter(item => item.id_procedimento_item);
        },

        lista_consumo: function () {

            if ( !this.item || !this.item.consumo_procedimentos )
                return [];

            return this.item.consumo_procedimentos.filter(item => !item.excluido);

        },

        lista_consumo_operadora () {

            if ( !this.edicaoConsumoProcedimento || !this.edicaoConsumoProcedimento.consumo_procedimento_operadoras )
                return [];

            return this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.filter(item => !item.excluido);

        },

        lista_dados: function () {
            //let reg = this.$util.getregex(this.search);
            // && ( !this.search || reg.test(JSON.stringify(item) ) )

            return this.dados && this.dados.data && this.dados.data.length ?
                this.dados.data.filter (item => {
                    return ( this.viewMode == 'T' || ( item.unidade_procedimento && item.unidade_procedimento.fl_ativo ) );
                })
                .map(item => {
                    if ( !item.unidade_procedimento )
                        item.unidade_procedimento = {
                            fl_ativo: false,
                            quebra: false,
                            id_procedimento: item.id_procedimento,
                            instrucao: {},
                        };

                    return item;
                }) : null ;
                /*
                _.groupBy(this.dados.filter (item => {
                    return !this.search || reg.test(JSON.stringify(item));
                }), function (item) {

                if ( !item.unidade_procedimento )
                    item.unidade_procedimento = {
                        fl_ativo: false,
                        quebra: false,
                        id_procedimento: item.id_procedimento,
                        instrucao: {},
                    };

                return item.unidade_procedimento.quebra;

            }) : null;
            */
        },
        exibirModalidadeDicom: function() {
          let exibir = false;

          if ( this.setup )
            return false;

          if ( this.item.id_classe_procedimento <= 1 )
            return false;

        //   if(this.config && this.config.length > 0) {
        //     return this.config[0].st_valor != "" && this.config[0].st_valor != undefined;
        //   }

          exibir = this.config && this.config.length > 0;

          return exibir;
        },

        lista_opcoes_filtro: function () {
            return [
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },

        lista_opcoes_filtro_atend: function () {
            return [
                {id:'tag-procedimento', search:'Classificação do Procedimento', service: 'procedimentos.index', parms: { ativos: true }, tag: true}, 
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },

        lista_amostras: function () {
            if ( !this.item || !this.item.amostras ) {
                return [];
            }

            return _.orderBy(
                _.orderBy(this.item.amostras, (item) => {
                    return _.get(item, 'amostra_material.search');
                }),
                'in_regra_ordem'
            );
        },

        lista_tabelas () { 
            if ( !this.tabelas )
                return [];

            let reg = this.$util.getregex(this.search_tabelas);

            return this.tabelas.filter(item => !this.search_tabelas || reg.test(JSON.stringify(item) ));
        },
    },

    methods: {
        refresh_prazos () { 
            this.editar (this.item);
        },

        // Outras Especialidades...

        incluir_espec () { 

            this.item.especs.push({
                id_procedimento: this.item.id_procedimento,
                id_especialidade: "", 
                excluido: false, 
            });

        },

        //

        filtrar_terceiro (terc) { 
            console.log('search', this.search, terc.id_terceiro);

            if ( this.search == ( '#T' + terc.id_terceiro ) ) { 
                this.search = ( '!#T' + terc.id_terceiro );
            } else { 
                this.search = ( '#T' + terc.id_terceiro );
            }
        },

        selecao_comp_unidades (comp) { 
            this.$refs.selunid.abrir(comp);
        },

        preview_markdown (instr, campo) { 
            this.$refs.markdown.abrir(instr, campo);
        },

        incluir_sinonimo () { 
            if ( !this.item.sinonimos )
                this.item.sinonimos = [];

            this.item.sinonimos.push({ 
                id_procedimento: this.item.id_procedimento, 
                st_descricao: "", 
                fl_ativo: true, 
                fl_lista: true, 
            });
        },

        incluir_centro_custo() { 
            this.item.centro_custos.push({ 
                id_procedimento_centro_custo: null, 
                id_procedimento: this.item.id_procedimento, 
                id_unidade_operacao: "",
                id_centro_custo: "", 
                excluido: false, 
            });
        },

        incluir_recurso() { 
            this.item.procedimento_equipamentos.push({ 
                id_procedimento_equipamento: null, 
                st_tipo: 'E', // this.lista_classes_recurso.length ? 'C' : 'E', 
                st_classe: "",
                id_equipamento: "", 
                excluido: false, 
            });
        },

        importar_componentes() { 
            this.$refs.imp_comp.iniciar_importacao();
        },

        vincular_tuss () { 
            if ( !confirm('Confirma vincular o procedimentos as tabelas pelo código TUSS?') )
                return;

            this.$util.atualizar(this, { 
                service: 'procedimentos', 
                func: 'vincular_tuss',
                dados: { 
                    codigo_tuss: this.item.st_codigo_cbhpm,
                    lista: this.tabelas,
                },
                callback: res => { 
                    this.vinculando = true;
                    
                    if ( res.lista ) { 
                        this.tabelas = res.lista;
                    }

                    this.$nextTick(() => { 
                        this.vinculando = false;
                    });

                    this.$toast.add({
                        severity: "success",
                        summary: 'Vincular TUSS',
                        detail: res.vinculados + " tabela(s) vinculada(s)",
                        life: 3000
                    });
                }
            });
        },

        atualizar_laudo() { 
            this.$util.atualizar(this, { 
                service: "procedimentos", 
                func: "atualizar_laudo", 
                dados: { 
                    lista: this.lista_dados.map(item => item.id_procedimento),
                    ...this.info, 
                },
                modal: "infoLaudoModal",
                toast: true,
                reload: true, 
            });
        },

        editar_laudo() { 
            $('#infoLaudoModal').modal('show');
        },

        incluir_colirio () { 
            if ( !this.novoColirio )
                return;

            if ( !this.item.medicamento_cobrancas ) { 
                this.item.medicamento_cobrancas = [];
                this.$forceUpdate();
            }

            if ( this.item.medicamento_cobrancas.find(mc => !mc.excluido && mc.id_medicamento == this.novoColirio.id_medicamento) ) { 

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Medicamento já selecionado: ' + this.novoColirio.search,
                    life: 3000
                });

            } else { 

                this.item.medicamento_cobrancas.push({
                    id_procedimento: this.item.id_procedimento, 
                    id_medicamento: this.novoColirio.id_medicamento, 
                    medicamento: this.novoColirio, 
                    excluido: false, 
                });

            }

            this.novoColirio = null;

            this.$nextTick(() => { 
                this.novoColirio = "";
            });
        },

        addTagProc (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        addTag (newTag) {
        
            if ( !this.item.js_complementos )
                this.item.js_complementos = [];

            this.item.js_complementos.push(newTag);

        },

        unico (lista, campo) {
            return _.uniqBy(lista, campo);
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        buscarItems () {
            if ( this.pesquisar_debounce )
                clearTimeout(this.pesquisar_debounce);

            this.pesquisar_debounce = setTimeout(() => {
                this.page = 1;
                this.load();
                clearTimeout(this.pesquisar_debounce);
            }, 300);
        },

        marcar_todos_medicos () {
            let marcar = false;

            if ( this.medicos.find(medico => !medico.medico_procedimento_unidade.fl_ativo) ) {
                marcar = true;
            }

            this.medicos.forEach(medico => {
                medico.medico_procedimento_unidade.fl_ativo = marcar;
            });
        },

        clonar_especialidades() { 

            this.$refs.proclista.abrir('procedimento', -1, (lista) => {

                if ( lista && lista.length ) {

                    this.$util.atualizar(this, {
                        service: 'procedimentos',
                        func: 'clonar_especialidades',
                        dados: {
                            id_procedimento: this.item.id_procedimento,
                            destino: lista,
                        },
                        modal: 'procedimentoListaModal',
                        toast: true,
                        msg: 'Clonagem realizada.'
                    });

                } else {

                    this.$toast.add({
                        severity: "error",
                        summary: "Clonar",
                        detail: 'Selecione os procedimentos desejados.',
                        life: 3000
                    });

                }
            });

        },

        clonar_componentes() {
            this.$refs.proclista.abrir('procedimento', -1, (lista) => {

                if ( lista && lista.length ) {

                    this.$util.atualizar(this, {
                        service: 'procedimentos',
                        func: 'clonar_procedimentos',
                        dados: {
                            id_procedimento: this.item.id_procedimento,
                            destino: lista,
                        },
                        modal: 'procedimentoListaModal',
                        toast: true,
                        msg: 'Clonagem realizada.'
                    });

                } else {

                    this.$toast.add({
                        severity: "error",
                        summary: "Clonar",
                        detail: 'Selecione os procedimentos desejados.',
                        life: 3000
                    });

                }
            });
        },

        remover_material(amostra) {
            if ( !confirm("Confirma remover o material?") )
                return;

            this.$util.remover(this, {
                service: 'procedimento_amostra_materiais',
                dados: amostra,
                toast: true,
                modal: 'amostraModal',
                callback: () => {
                    this.editar (this.item);
                }
            });
        },

        editar_material(amostra) {
            this.validate = false;
            this.amostra = _.cloneDeep(amostra);

            $('#amostraModal').modal('show');
        },

        atualizar_material() {
            this.$util.atualizar(this, {
                service: 'procedimento_amostra_materiais',
                dados: this.amostra,
                toast: true,
                modal: 'amostraModal',
                callback: () => {
                    this.editar (this.item);
                }
            });
        },

        remover_terceiro () {
            if ( !confirm("Confirma remover este item?") )
                return;

            this.$util.remover(this, {
                service: 'procedimento_terceiros',
                dados: this.terceiro,
                modal: 'terceiroModal',
                toast: true,
                callback: () => {
                    this.editar (this.item);
                }
            });
        },

        salvar_terceiro() {
            this.$util.atualizar(this, {
                service: 'procedimento_terceiros',
                func: 'store',
                dados: this.terceiro,
                modal: 'terceiroModal',
                toast: true,
                callback: () => {
                    this.editar (this.item);
                }
            });
        },

        editar_terceiro(item) {
            this.$refs.depara.editar(item.id_procedimento_terceiro);

            /*
            this.validate = false;
            this.terceiro = _.cloneDeep(item);

            if ( this.terceiro.id_amostra_material === null ) {
                this.terceiro.id_amostra_material = "";
            }

            $('#terceiroModal').modal('show');
            */
        },

        incluir_terceiro(item) {
            this.$refs.depara.incluir_terceiro({ id_procedimento: item.id_procedimento });

            /*
            this.validate = false;

            this.terceiro = {
                id_procedimento_terceiro: null,
                id_procedimento: item.id_procedimento,
                id_terceiro: null,
                id_amostra_material: "",
                st_codigo_terceiro: "",
                st_material_terceiro: "",
                fl_ativo: true,
                in_regra_ordem: 100,
                filtros: [],
            };

            $('#terceiroModal').modal('show');
            */
        },

        incluir_material(item) {
            this.validate = false;

            this.amostra = {
                id_procedimento_amostra_material: null,
                id_procedimento: item.id_procedimento,
                id_amostra_material: "",
                fl_padrao: this.lista_amostras.length ? false : true,
                in_regra_ordem: 100,
                excluido: false,
            };

            $('#amostraModal').modal('show');
        },

        selecionarProcedimento() {
            if ( this.busca_procedimento ) {
                this.especialidade = this.busca_procedimento.especialidade;
                this.search = '#' + this.busca_procedimento.id_procedimento;
                this.busca_procedimento = null;
            }
        },

        idade_em_anos(idade_meses) {
            return Math.round(idade_meses / 12);
        },
        acessarTabela (tabela, item) {
            if ( !item ) {
                this.$refs.cadtab.incluirItemParaProcedimento(tabela, this.item, this.reloadItem);
            } else {
                this.$refs.cadtab.abrirItemTabela(item.id_item_tabela, this.reloadItem, tabela);
            }
        },

        incluirItemTabela (tabela) {
            this.$refs.cadtab.incluirItem(tabela);
        },

        configurarPorOperadora (item) {
            this.novaOperadora = null;
            this.consumoProcedimento = item;
            this.edicaoConsumoProcedimento = { ...item };

            $('[data-toggle="tooltip"]').tooltip('dispose');

            $('#consumoOperadoraModal').modal('show');
        },

        confirmarConfiguracaoPorOperadora () {
            this.consumoProcedimento.consumo_procedimento_operadoras = this.edicaoConsumoProcedimento.consumo_procedimento_operadoras;

            $('#consumoOperadoraModal').modal('hide');
        },

        incluirComponente () {
            if ( !this.novoComponente )
                return;

            let novo = _.cloneDeep(this.novoComponente);
            this.novoComponente = "";

            this.item.consumo_procedimentos.push({
                id_consumo_procedimento: null,
                id_procedimento: this.item.id_procedimento,
                id_taxa: novo.id_taxa,
                id_material: novo.id_material,
                id_medicamento: novo.id_medicamento,
                id_procedimento_item: novo.id_procedimento,
                dc_quantidade: 1,
                fl_nao_repetir: false,
                fl_block_valor: false, 
                fl_block_laudo: false, 
                search: novo.search,
                excluido: false,
                consumo_procedimento_operadoras: [],
                outro_medico: false,
                id_medico: null,
                tem_filtros: false,
                in_idade_min: "",
                in_idade_max: "",
                ch_sexo: "",
                procedimento_item: ( ( novo && novo.id_procedimento ) ? novo : null ),
                fl_unidades_regra: 0, 
                js_unidades: null, 
                lista_unidades: [], 
            });

            this.$nextTick(() => {
                this.novoComponente = null;
            });

        },

        incluirOperadora () {
            if ( !this.novaOperadora )
                return;

            this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.push({
                id_consumo_procedimento_operadora: null,
                id_operadora: this.novaOperadora.id_operadora,
                id_consumo_procedimento: this.consumoProcedimento.id_consumo_procedimento,
                in_quantidade: this.consumoProcedimento.dc_quantidade,
                excluido: false,
                operadora: {
                    search: this.novaOperadora.search,
                }
            });

            this.novaOperadora = "";

            this.$nextTick(() => {
                this.novaOperadora = null;
            });

        },

        incluirOperadoraPlano () {
            if ( !this.novaOperadoraPlano )
                return;

            this.edicaoConsumoProcedimento.consumo_procedimento_operadoras.push({
                id_consumo_procedimento_operadora: null,
                id_operadora: this.novaOperadoraPlano.id_operadora,
                id_plano: this.novaOperadoraPlano.id_plano,
                id_consumo_procedimento: this.consumoProcedimento.id_consumo_procedimento,
                in_quantidade: this.consumoProcedimento.dc_quantidade,
                excluido: false,
                operadora: {
                    search: this.novaOperadoraPlano.search,
                },
                plano: {
                    search: this.novaOperadoraPlano.search,
                },
            });

            this.novaOperadoraPlano = "";

            this.$nextTick(() => {
                this.novaOperadoraPlano = null;
            });

        },

        enableAll(enable) {
            if ( !confirm('Confirma ' + ( enable ? 'habilitar' : 'desabilitar') + ' todos os procedimentos dessa especialidade?') ) {
                return; 
            }

            this.$util.atualizar (this, {
                service: 'procedimentos',
                func: 'habilitar',
                dados: {
                    id_especialidade: this.especialidade.id_especialidade,
                    habilitar: enable,
                },
                callback: () => {
                    this.load();
                }
            });
        },
        incluir_procedimento () {
            this.validate = false;

            this.item = {
                especialidade: this.especialidade,
                id_especialidade: this.especialidade.id_especialidade,
                unidade_procedimento: {
                    instrucao: {
                        st_instrucao: "",
                        st_instrucao_agenda_online: "",
                    },
                },
                medicamento_cobrancas: [], 
            };
            this.em_edicao = true;
        },
        clonar_procedimento () { 
            this.validate = false;

            let base = _.cloneDeep(this.item);

            this.item = {
                especialidade: this.especialidade,
                id_especialidade: this.especialidade.id_especialidade,
                id_classe_procedimento: base.id_classe_procedimento, 
                id_modalidade_dicom: base.id_modalidade_dicom, 
                id_status_laudo: base.id_status_laudo, 
                id_procedimento_grupo: base.id_procedimento_grupo, 
                fl_nao_consultorio: base.fl_nao_consultorio, 
                unidade_procedimento: {
                    instrucao: {
                        st_instrucao: "",
                        st_instrucao_agenda_online: "",
                    },
                },
                medicamento_cobrancas: [], 
            };
            this.em_edicao = true;
        },
        load () {
            this.$store.commit('setContexto',
                {
                    especialidade: this.especialidade ? this.especialidade.id_especialidade : null,
                });

            this.$store.commit('loading', true);

            let filtro = {};

            if ( this.id_procedimento && this.link ) {
                filtro = { where: { id_procedimento: this.id_procedimento } };
            } else {
                filtro = { where: { id_especialidade: this.especialidade ? this.especialidade.id_especialidade : -1 } };

                if ( this.classificacao ) { 
                    filtro.where.id_classe_procedimento = this.classificacao;
                }
            }

            let query = { q: [
                {
                    name: 'procedimentos.index',
                    id: 'lista',
                    parms: {
                        lista_cadastro: true,
                        ...filtro,
                        cadastro: true,
                        busca: this.search,
                        size: 100,
                        page: this.page,
                        ativos: ( this.viewMode == 'A' ),
                        filtro_material: ( this.especialidade && this.especialidade.id_especialidade == 2 ) ? this.filtro_material : 'T',
                    }
                },
                {
                    name: 'configuracao_pacs.index',
                    id: 'config',
                    parms: {
                      where: {
                        // st_slug: 'integracap-pacs',
                        fl_ativo: '1',
                      }
                    }
                },
                {
                    name: 'configuracoes.index',
                    id: 'configdescr',
                    parms: {
                      where: {
                        st_slug: 'proced-descr-paciente',
                        fl_ativo: '1',
                      }
                    }
                }
            ]};

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.axios.post('/aql?a=procedimentos.index&page=' + this.page, query, {
                    cancelToken: this.canceltoken.token,
                })
                .then(res => {
                    if ( res.data && res.data.lista.status == 200 ) {
                        this.dados = res.data.lista.data;
                        this.config = res.data.config.data;
                        this.configdescr = _.first(res.data.configdescr.data);

                        if ( this.id_procedimento && this.dados.total == 1 && this.dados.data.length == 1) {
                            this.editar (this.dados.data[0]);
                        }
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
        },
        reloadItem () {
            this.editar (this.item);
        },

        editar (item) {

            if ( !this.em_edicao ) {
                this.$store.commit('loading', true);
                this.item = null;
                this.em_edicao = true;
            }

            this.validate = false;

            if ( !this.id_procedimento && !this.setup ) {
                this.$router.replace({ name: 'c-procedimentos', params: { id_procedimento: item.id_procedimento }});
            }

            let query = { q: [
                {
                    name: 'procedimentos.show',
                    id: 'procedimento',
                    parms: {
                        id: item.id_procedimento,
                        cadastro: true,
                    }
                },
                {
                    name: 'tabela_versaos.index',
                    id: 'tabelas',
                    parms: {
                        id_procedimento: item.id_procedimento,
                        cadastro_procedimento: true,
                    }
                },
                {
                    name: 'medico_unidades.index',
                    id: 'medicos',
                    parms: {
                        id_procedimento: item.id_procedimento,
                    }
                },
                {
                    name: 'terceiros.index',
                    id: 'terceiros'
                },
                {
                    name: 'modelos.index',
                    id: 'modelos',
                    parms: { 
                        mode: 'selecao', 
                        cad_procedimento: true,
                        id_procedimento: item.id_procedimento, 
                    }

                },
            ]};

            if ( this.equipamentos === null ) { 
                query.q.push({ 
                    name: 'equipamentos.index', 
                    id: 'equipamentos', 
                    parms: { 
                        ativos: true 
                    }
                });
            }

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.terceiros.status == 200 ) {
                        this.terceiros = res.data.terceiros.data;
                    }

                    if ( res.data.modelos.status == 200 ) {
                        this.modelos = res.data.modelos.data;
                    } else { 
                        this.modelos = [];
                    }

                    if ( res.data.procedimento.status == 200 ) {
                        this.item = res.data.procedimento.data;

                        if ( !this.item.js_complementos ) {
                            this.item.js_complementos = [];
                        }

                        if ( this.item.id_status_laudo == null ) {
                            this.item.id_status_laudo = "";
                        }

                        if ( !this.item.unidade_procedimento.instrucao ) {
                            this.item.unidade_procedimento.instrucao = {
                                id_instrucao_procedimento: null,
                                id_unidade_procedimento: this.item.unidade_procedimento.id_unidade_procedimento,
                                st_instrucao: "",
                            };
                        }

                        if ( !this.em_edicao ) {
                            this.em_edicao = true;
                            window.scrollTo(0,0);
                        }

                        if ( this.item.st_procedimento && !this.setup ) {
                            let bc = _.cloneDeep(this.breadcrumb);
                            bc.push({ name: this.item.st_procedimento, path: "" });
                            this.$store.commit('setBreadcrumb', bc);
                        }
                    }

                    if ( res.data.tabelas.status == 200 ) {
                        this.tabelas = res.data.tabelas.data;
                    }

                    if ( res.data.medicos.status == 200 ) {
                        this.medicos = res.data.medicos.data;
                        this.medicos.forEach(element => {
                            if ( !element.medico_procedimento_unidade )
                                element.medico_procedimento_unidade = {
                                    fl_ativo: false,
                                    id_procedimento: this.item.id_procedimento,
                                };
                        });
                    }

                    if ( res.data.equipamentos && res.data.equipamentos.status == 200 ) {
                        this.equipamentos = res.data.equipamentos.data;
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        },
        remover () {
            alert('Em desenvolvimento...');
        },
        atualizar () {

            this.validate = true;

            this.$nextTick (() => {

                let invalids = $('.invalid').is(":visible");

                if ( invalids.length ) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else {

                    this.$store.commit('loading', true);

                    let query = { q: [
                        {
                            name: 'procedimentos.store',
                            id: 'atualizar',
                            parms: {
                                ...this.item,
                            }
                        }
                    ]};

                    if ( this.item.id_procedimento ) {

                        query.q.push({
                            name: 'procedimento_item_tabelas.store',
                            id: 'tabelas',
                            parms: {
                                ...this.tabelas,
                            }
                        });

                        query.q.push({
                            name: 'medico_unidades.update_procedimento',
                            id: 'medicos',
                            parms: {
                                ...this.medicos,
                            }
                        });

                    }

                    this.axios.post('/aql', query)
                        .then (res => {
                            if ( res.data.atualizar.status == 200 ) {
                                this.load();

                                if ( !this.item.id_procedimento || 1 == 1) {

                                    this.editar (res.data.atualizar.data);

                                } else {

                                    if ( res.data.tabelas.status == 200 )
                                        this.tabelas = res.data.tabelas.data;

                                    if ( res.data.medicos.status == 200 )
                                        this.medicos = res.data.medicos.data;

                                }

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => {
                            this.$store.commit('loading', false);
                        });

                }

            });

        },
        fechar () {
            if ( this.id_procedimento && this.link ) {
                this.$router.go(-1);
            } else {
                this.em_edicao = false;

                if ( !this.setup ) {
                    this.$router.replace({ name: 'c-procedimentos' });
                    this.$store.commit('setBreadcrumb', this.breadcrumb);
                }
            }
        },
        toggle_procedimento (item) {

            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'unidade_procedimentos.toggle',
                    id: 'toggle',
                    parms: {
                        incluir: true,
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.toggle.status == 200 ) {
                        let result = res.data.toggle.data;
                        item.id_unidade_procedimento = result.id_unidade_procedimento;
                        item.fl_ativo = result.fl_ativo;
                        item.quebra = result.fl_ativo;
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });


        },

    },

    created () {

        if ( this.$store.state.contexto.especialidade ) {

            let lista = this.$store.state.options['esp-ativas'];

            if ( lista ) {
                let item = lista.find(it => {
                    return it.id_especialidade == this.$store.state.contexto.especialidade;
                });

                if ( item ) {
                    this.especialidade = item;
                }
            }

        }

    },

    beforeMount() {
        if ( this.id_procedimento && !this.link ) {
            this.link = true;
        }
    },

    mounted () {
        this.load ();

        this.$util.loadItem(this, { 
            service: 'procedimentos',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        if ( !this.link ) {

            if ( !this.setup ) {

                this.breadcrumb = [
                        { name: "Configurações", path: "/cadastros"},
                        { name: "Procedimentos", method: this.fechar },
                    ];

                this.$store.commit('setBreadcrumb', this.breadcrumb);

            } else {

                this.viewMode = 'T';

            }

        } else {

            this.breadcrumb = this.$store.state.breadcrumb;

        }

    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>